import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, QueryList, ChangeDetectorRef, TemplateRef, ViewChild, ViewContainerRef, HostBinding, Directive, NgModule, ɵɵdefineInjectable, Injectable, ContentChild, ElementRef, Pipe } from '@angular/core';
import { CdkTable, CdkTableModule } from '@angular/cdk/table';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbPaginationConfig, NgbPaginationEllipsis, NgbPaginationFirst, NgbPaginationLast, NgbPaginationNext, NgbPaginationNumber, NgbPaginationPrevious, NgbAlertModule, NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DownloaderService, CommonModule as CommonModule$1, DateUtils, TimeUtils, GeneralSettingValueService, SocietiesService } from '@pwc/common';
import { FormsModule } from '@angular/forms';
import { isNullOrUndefined } from 'util';
import { faCircleNotch, faAngleLeft, faAngleRight, faTimesCircle, faCheckCircle, faTimes, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { Observable } from 'rxjs';
import { NgxSmartModalService, NgxSmartModalModule } from 'ngx-smart-modal';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@pwc/i18n';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { DomSanitizer } from '@angular/platform-browser';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { switchMap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@fortawesome/angular-fontawesome';
import * as ɵngcc3 from '@angular/cdk/table';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@ngneat/content-loader';
import * as ɵngcc6 from 'ngx-smart-modal';
import * as ɵngcc7 from '@ngx-translate/core';
import * as ɵngcc8 from '@angular/router';
import * as ɵngcc9 from '@ng-select/ng-select';
import * as ɵngcc10 from '@pwc/common';
import * as ɵngcc11 from '@angular/platform-browser';

function BadgeListComponent_div_0_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.label);
} }
function BadgeListComponent_div_0_span_3_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function BadgeListComponent_div_0_span_3_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const item_r3 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.removeItem(item_r3.id); });
    ɵngcc0.ɵɵtext(1, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
} }
function BadgeListComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, BadgeListComponent_div_0_span_3_a_2_Template, 2, 0, "a", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r3.canRemove);
} }
function BadgeListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, BadgeListComponent_div_0_label_1_Template, 2, 1, "label", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, BadgeListComponent_div_0_span_3_Template, 3, 2, "span", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function ButtonComponent_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", ctx_r0.faCircleNotch)("spin", true);
} }
const _c0 = ["*"];
function CollapsableComponent_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "open"]);
} }
function DataTableComponent_ng_container_2_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "input", 11);
    ɵngcc0.ɵɵlistener("change", function DataTableComponent_ng_container_2_th_1_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.selectVisibleRows(); })("ngModelChange", function DataTableComponent_ng_container_2_th_1_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.allSelected = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "label", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.allSelected);
} }
const _c1 = function () { return { standalone: true }; };
function DataTableComponent_ng_container_2_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "input", 14);
    ɵngcc0.ɵɵlistener("change", function DataTableComponent_ng_container_2_td_2_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r13); const row_r11 = ctx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.selectRows(row_r11.id); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "label", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", row_r11.selected)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(6, _c1))("ngModel", row_r11.selected);
    ɵngcc0.ɵɵattribute("id", row_r11.id)("name", row_r11.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", row_r11.id);
} }
function DataTableComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 6);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_2_th_1_Template, 4, 1, "th", 7);
    ɵngcc0.ɵɵtemplate(2, DataTableComponent_ng_container_2_td_2_Template, 4, 7, "td", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DataTableComponent_ng_container_3_ng_container_1_th_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 22);
} }
function DataTableComponent_ng_container_3_ng_container_1_th_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 23);
} }
function DataTableComponent_ng_container_3_ng_container_1_th_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 24);
} }
function DataTableComponent_ng_container_3_ng_container_1_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 18);
    ɵngcc0.ɵɵlistener("sort", function DataTableComponent_ng_container_3_ng_container_1_th_1_Template_th_sort_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.onSort($event); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, DataTableComponent_ng_container_3_ng_container_1_th_1_span_2_Template, 1, 0, "span", 19);
    ɵngcc0.ɵɵtemplate(3, DataTableComponent_ng_container_3_ng_container_1_th_1_span_3_Template, 1, 0, "span", 20);
    ɵngcc0.ɵɵtemplate(4, DataTableComponent_ng_container_3_ng_container_1_th_1_span_4_Template, 1, 0, "span", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r14 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r19 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r19.getColumnStyle(column_r14))("sortable", column_r14.field);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", column_r14.header, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.sortType == column_r14.field && ctx_r19.sortReverse == 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.sortType == column_r14.field && ctx_r19.sortReverse == 2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.sortType == column_r14.field && ctx_r19.sortReverse == 0);
} }
function DataTableComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_3_ng_container_1_th_1_Template, 5, 6, "th", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DataTableComponent_ng_container_3_ng_container_2_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 26);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r14 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r26 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r26.getColumnStyle(column_r14));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", column_r14.header, " ");
} }
function DataTableComponent_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_3_ng_container_2_th_1_Template, 2, 2, "th", 25);
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c2 = function (a0) { return { pointer: a0 }; };
function DataTableComponent_ng_container_3_ng_container_3_td_1_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 28);
    ɵngcc0.ɵɵlistener("dblclick", function DataTableComponent_ng_container_3_ng_container_3_td_1_Template_td_dblclick_0_listener() { ɵngcc0.ɵɵrestoreView(_r32); const row_r29 = ctx.$implicit; const column_r14 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.handleDoubleClick(column_r14, row_r29); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r29 = ctx.$implicit;
    const column_r14 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r28 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx_r28.hasDblClickHandler(column_r14)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(column_r14.cell(row_r29));
} }
function DataTableComponent_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_3_ng_container_3_td_1_Template, 2, 4, "td", 27);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DataTableComponent_ng_container_3_ng_container_4_td_1_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 30);
    ɵngcc0.ɵɵlistener("dblclick", function DataTableComponent_ng_container_3_ng_container_4_td_1_Template_td_dblclick_0_listener() { ɵngcc0.ɵɵrestoreView(_r38); const row_r35 = ctx.$implicit; const column_r14 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r36 = ɵngcc0.ɵɵnextContext(); return ctx_r36.handleDoubleClick(column_r14, row_r35); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r35 = ctx.$implicit;
    const column_r14 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r34 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx_r34.hasDblClickHandler(column_r14)))("innerHTML", column_r14.cell(row_r35), ɵngcc0.ɵɵsanitizeHtml);
} }
function DataTableComponent_ng_container_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_3_ng_container_4_td_1_Template, 1, 4, "td", 29);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DataTableComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 16);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_3_ng_container_1_Template, 2, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, DataTableComponent_ng_container_3_ng_container_2_Template, 2, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(3, DataTableComponent_ng_container_3_ng_container_3_Template, 2, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(4, DataTableComponent_ng_container_3_ng_container_4_Template, 2, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cdkColumnDef", column_r14.field);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r14.sortable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r14.sortable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r14.raw);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r14.raw);
} }
function DataTableComponent_tr_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 31);
} }
function DataTableComponent_ng_container_6_tr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 33);
} }
function DataTableComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_6_tr_1_Template, 1, 0, "tr", 32);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkRowDefColumns", ctx_r3.displayedColumns);
} }
function DataTableComponent_ng_container_7_tr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 35);
} if (rf & 2) {
    const row_r43 = ctx.$implicit;
    const ctx_r42 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("detailRow", row_r43)("detailRowTpl", ctx_r42.detailRowTpl)("expand", !row_r43.collapsed);
} }
function DataTableComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_7_tr_1_Template, 1, 3, "tr", 34);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkRowDefColumns", ctx_r4.displayedColumns);
} }
function DataTableComponent_ng_container_8_content_loader_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "content-loader", 37);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(1, "rect", 38);
    ɵngcc0.ɵɵelement(2, "rect", 39);
    ɵngcc0.ɵɵelement(3, "rect", 40);
    ɵngcc0.ɵɵelement(4, "rect", 41);
    ɵngcc0.ɵɵelement(5, "rect", 42);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("viewBox", "0 0 800 120");
} }
function DataTableComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DataTableComponent_ng_container_8_content_loader_1_Template, 6, 1, "content-loader", 36);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r5.loading$));
} }
const _c3 = function (a0) { return { "table-hover": a0 }; };
const _c4 = [[["", "toolbar-actions", ""]], [["", "toolbar-text", ""]]];
const _c5 = ["[toolbar-actions]", "[toolbar-text]"];
function AlertComponent_h5_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "h5", 3);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("innerHTML", _r0.getData().message, ɵngcc0.ɵɵsanitizeHtml);
} }
function ModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementEnd();
} }
const _c6 = [[["", "modal-title", ""]], [["", "modal-body", ""]], [["", "modal-footer", ""]]];
const _c7 = ["[modal-title]", "[modal-body]", "[modal-footer]"];
const _c8 = ["confirmationModal"];
function ConfirmationModalComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function ConfirmationModalComponent_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onNegativeClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r1.negativeButtonText));
} }
function ConfirmationModalComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ConfirmationModalComponent_button_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onPositiveClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r2.positiveButtonText));
} }
function SortingArrowsComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} }
function SortingArrowsComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} }
function SortingArrowsComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 5);
} }
var I18N_9;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    const MSG_EXTERNAL_ngb_pagination_first$$FESM2015_PWC_UI_JS__10 = goog.getMsg("\u00AB\u00AB");
    I18N_9 = MSG_EXTERNAL_ngb_pagination_first$$FESM2015_PWC_UI_JS__10;
}
else {
    I18N_9 = $localize `:@@ngb.pagination.first␟656506dfd46380956a655f919f1498d018f75ca0␟6867721956102594380:««`;
}
function PaginationComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵi18n(1, I18N_9);
    ɵngcc0.ɵɵelementEnd();
} }
var I18N_11;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    const MSG_EXTERNAL_ngb_pagination_previous$$FESM2015_PWC_UI_JS__12 = goog.getMsg("{$startTagFaIcon}{$closeTagFaIcon}", { "startTagFaIcon": "\uFFFD#2\uFFFD", "closeTagFaIcon": "\uFFFD/#2\uFFFD" });
    I18N_11 = MSG_EXTERNAL_ngb_pagination_previous$$FESM2015_PWC_UI_JS__12;
}
else {
    I18N_11 = $localize `:@@ngb.pagination.previous␟d702e1238b2e0759044019f6abbbd9c2ac8bb394␟5762149050202037418:${"\uFFFD#2\uFFFD"}:START_TAG_FA_ICON:${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_FA_ICON:`;
}
function PaginationComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵi18nStart(1, I18N_11);
    ɵngcc0.ɵɵelement(2, "fa-icon", 14);
    ɵngcc0.ɵɵi18nEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r3.faAngleLeft);
} }
var I18N_13;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    const MSG_EXTERNAL_ngb_pagination_next$$FESM2015_PWC_UI_JS__14 = goog.getMsg("{$startTagFaIcon}{$closeTagFaIcon}", { "startTagFaIcon": "\uFFFD#2\uFFFD", "closeTagFaIcon": "\uFFFD/#2\uFFFD" });
    I18N_13 = MSG_EXTERNAL_ngb_pagination_next$$FESM2015_PWC_UI_JS__14;
}
else {
    I18N_13 = $localize `:@@ngb.pagination.next␟d702e1238b2e0759044019f6abbbd9c2ac8bb394␟5762149050202037418:${"\uFFFD#2\uFFFD"}:START_TAG_FA_ICON:${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_FA_ICON:`;
}
function PaginationComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵi18nStart(1, I18N_13);
    ɵngcc0.ɵɵelement(2, "fa-icon", 14);
    ɵngcc0.ɵɵi18nEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r5.faAngleRight);
} }
var I18N_15;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    const MSG_EXTERNAL_ngb_pagination_last$$FESM2015_PWC_UI_JS__16 = goog.getMsg("\u00BB\u00BB");
    I18N_15 = MSG_EXTERNAL_ngb_pagination_last$$FESM2015_PWC_UI_JS__16;
}
else {
    I18N_15 = $localize `:@@ngb.pagination.last␟49f27a460bc97e7e00be5b37098bfa79884fc7d9␟5277020320267646988:»»`;
}
function PaginationComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵi18n(1, I18N_15);
    ɵngcc0.ɵɵelementEnd();
} }
function PaginationComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "...");
} }
function PaginationComponent_ng_template_10_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵtext(1, "(current)");
    ɵngcc0.ɵɵelementEnd();
} }
function PaginationComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵtemplate(1, PaginationComponent_ng_template_10_span_1_Template, 2, 0, "span", 15);
} if (rf & 2) {
    const page_r17 = ctx.$implicit;
    const currentPage_r18 = ctx.currentPage;
    ɵngcc0.ɵɵtextInterpolate1(" ", page_r17, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", page_r17 === currentPage_r18);
} }
var I18N_17;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    const MSG_EXTERNAL_ngb_pagination_first_aria$$FESM2015_PWC_UI_JS__18 = goog.getMsg("First");
    I18N_17 = MSG_EXTERNAL_ngb_pagination_first_aria$$FESM2015_PWC_UI_JS__18;
}
else {
    I18N_17 = $localize `:@@ngb.pagination.first-aria␟f2f852318759c6396b5d3d17031d53817d7b38cc␟2241508602425256033:First`;
}
const _c19 = ["aria-label", I18N_17];
function PaginationComponent_li_13_ng_template_3_Template(rf, ctx) { }
const _c20 = function (a0, a1) { return { disabled: a0, currentPage: a1 }; };
function PaginationComponent_li_13_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 17);
    ɵngcc0.ɵɵelementStart(1, "a", 18);
    ɵngcc0.ɵɵi18nAttributes(2, _c19);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_li_13_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); ctx_r21.selectPage(1); return $event.preventDefault(); });
    ɵngcc0.ɵɵtemplate(3, PaginationComponent_li_13_ng_template_3_Template, 0, 0, "ng-template", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r12.previousDisabled());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r12.hasPrevious() ? null : "-1");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", (ctx_r12.tplFirst == null ? null : ctx_r12.tplFirst.templateRef) || _r0)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(5, _c20, ctx_r12.previousDisabled(), ctx_r12.page));
} }
var I18N_21;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    const MSG_EXTERNAL_ngb_pagination_previous_aria$$FESM2015_PWC_UI_JS__22 = goog.getMsg("Previous");
    I18N_21 = MSG_EXTERNAL_ngb_pagination_previous_aria$$FESM2015_PWC_UI_JS__22;
}
else {
    I18N_21 = $localize `:@@ngb.pagination.previous-aria␟680d5c75b7fd8d37961083608b9fcdc4167b4c43␟4452427314943113135:Previous`;
}
const _c23 = ["aria-label", I18N_21];
function PaginationComponent_li_14_ng_template_3_Template(rf, ctx) { }
const _c24 = function (a0) { return { disabled: a0 }; };
function PaginationComponent_li_14_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 17);
    ɵngcc0.ɵɵelementStart(1, "a", 18);
    ɵngcc0.ɵɵi18nAttributes(2, _c23);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_li_14_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); ctx_r24.selectPage(ctx_r24.page - 1); return $event.preventDefault(); });
    ɵngcc0.ɵɵtemplate(3, PaginationComponent_li_14_ng_template_3_Template, 0, 0, "ng-template", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r13.previousDisabled());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r13.hasPrevious() ? null : "-1");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", (ctx_r13.tplPrevious == null ? null : ctx_r13.tplPrevious.templateRef) || _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(5, _c24, ctx_r13.previousDisabled()));
} }
var I18N_25;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    const MSG_EXTERNAL_ngb_pagination_next_aria$$FESM2015_PWC_UI_JS__26 = goog.getMsg("Next");
    I18N_25 = MSG_EXTERNAL_ngb_pagination_next_aria$$FESM2015_PWC_UI_JS__26;
}
else {
    I18N_25 = $localize `:@@ngb.pagination.next-aria␟f732c304c7433e5a83ffcd862c3dce709a0f4982␟3885497195825665706:Next`;
}
const _c27 = ["aria-label", I18N_25];
function PaginationComponent_li_21_ng_template_3_Template(rf, ctx) { }
function PaginationComponent_li_21_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 17);
    ɵngcc0.ɵɵelementStart(1, "a", 18);
    ɵngcc0.ɵɵi18nAttributes(2, _c27);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_li_21_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); ctx_r27.selectPage(ctx_r27.page + 1); return $event.preventDefault(); });
    ɵngcc0.ɵɵtemplate(3, PaginationComponent_li_21_ng_template_3_Template, 0, 0, "ng-template", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r14.nextDisabled());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r14.hasNext() ? null : "-1");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", (ctx_r14.tplNext == null ? null : ctx_r14.tplNext.templateRef) || _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(5, _c20, ctx_r14.nextDisabled(), ctx_r14.page));
} }
var I18N_28;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    const MSG_EXTERNAL_ngb_pagination_last_aria$$FESM2015_PWC_UI_JS__29 = goog.getMsg("Last");
    I18N_28 = MSG_EXTERNAL_ngb_pagination_last_aria$$FESM2015_PWC_UI_JS__29;
}
else {
    I18N_28 = $localize `:@@ngb.pagination.last-aria␟5c729788ba138508aca1bec050b610f7bf81db3e␟4882268002141858767:Last`;
}
const _c30 = ["aria-label", I18N_28];
function PaginationComponent_li_22_ng_template_3_Template(rf, ctx) { }
function PaginationComponent_li_22_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 17);
    ɵngcc0.ɵɵelementStart(1, "a", 18);
    ɵngcc0.ɵɵi18nAttributes(2, _c30);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_li_22_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(); ctx_r30.selectPage(ctx_r30.pageCount); return $event.preventDefault(); });
    ɵngcc0.ɵɵtemplate(3, PaginationComponent_li_22_ng_template_3_Template, 0, 0, "ng-template", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r15.nextDisabled());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r15.hasNext() ? null : "-1");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", (ctx_r15.tplLast == null ? null : ctx_r15.tplLast.templateRef) || _r6)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(5, _c20, ctx_r15.nextDisabled(), ctx_r15.page));
} }
function PaginationComponent_li_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 20);
    ɵngcc0.ɵɵelementStart(1, "span", 21);
    ɵngcc0.ɵɵtext(2, "pagination.collection-size");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r16.collectionSize);
} }
function BreadcrumbsComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 6);
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", item_r1.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r1.label);
} }
const _c31 = function (a0) { return { rows: a0 }; };
function PageSizeSelectorComponent_ng_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ng-option", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", option_r1.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind2(2, 2, "generic.action.switch-row-per-page", ɵngcc0.ɵɵpureFunction1(5, _c31, option_r1.value)), " ");
} }
const _c32 = ["download"];
function DownloaderQueueComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1, "downloader.header.in-progress");
    ɵngcc0.ɵɵelementEnd();
} }
function DownloaderQueueComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1, "downloader.header.success");
    ɵngcc0.ɵɵelementEnd();
} }
function DownloaderQueueComponent_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1, "downloader.header.error");
    ɵngcc0.ɵɵelementEnd();
} }
function DownloaderQueueComponent_div_0_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DownloaderQueueComponent_div_0_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.hideList(); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r5.faAngleDown);
} }
function DownloaderQueueComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DownloaderQueueComponent_div_0_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.showList(); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r6.faAngleUp);
} }
function DownloaderQueueComponent_div_0_ul_11_li_1_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 22);
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("icon", ctx_r14.faCircleNotch)("spin", true);
} }
function DownloaderQueueComponent_div_0_ul_11_li_1_fa_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 23);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("icon", ctx_r15.faTimesCircle);
} }
function DownloaderQueueComponent_div_0_ul_11_li_1_fa_icon_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 24);
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("icon", ctx_r16.faCheckCircle);
} }
const _c33 = function (a0) { return { "text-danger": a0 }; };
function DownloaderQueueComponent_div_0_ul_11_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 17);
    ɵngcc0.ɵɵtemplate(4, DownloaderQueueComponent_div_0_ul_11_li_1_fa_icon_4_Template, 1, 2, "fa-icon", 18);
    ɵngcc0.ɵɵtemplate(5, DownloaderQueueComponent_div_0_ul_11_li_1_fa_icon_5_Template, 1, 1, "fa-icon", 19);
    ɵngcc0.ɵɵelementStart(6, "a", 20);
    ɵngcc0.ɵɵlistener("click", function DownloaderQueueComponent_div_0_ul_11_li_1_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r18); const item_r13 = ctx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(3); return ctx_r17.openFile(item_r13); });
    ɵngcc0.ɵɵtemplate(7, DownloaderQueueComponent_div_0_ul_11_li_1_fa_icon_7_Template, 1, 1, "fa-icon", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c33, item_r13.isError));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r13.fileName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r13.isProgress);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r13.isError && !item_r13.isProgress);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r13.isSuccess && !item_r13.isProgress);
} }
function DownloaderQueueComponent_div_0_ul_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 13);
    ɵngcc0.ɵɵtemplate(1, DownloaderQueueComponent_div_0_ul_11_li_1_Template, 8, 7, "li", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.downloaderService.queue);
} }
function DownloaderQueueComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵtemplate(3, DownloaderQueueComponent_div_0_span_3_Template, 2, 0, "span", 6);
    ɵngcc0.ɵɵtemplate(4, DownloaderQueueComponent_div_0_span_4_Template, 2, 0, "span", 6);
    ɵngcc0.ɵɵtemplate(5, DownloaderQueueComponent_div_0_span_5_Template, 2, 0, "span", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵtemplate(7, DownloaderQueueComponent_div_0_button_7_Template, 2, 1, "button", 8);
    ɵngcc0.ɵɵtemplate(8, DownloaderQueueComponent_div_0_button_8_Template, 2, 1, "button", 8);
    ɵngcc0.ɵɵelementStart(9, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DownloaderQueueComponent_div_0_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.closeDialog(); });
    ɵngcc0.ɵɵelement(10, "fa-icon", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, DownloaderQueueComponent_div_0_ul_11_Template, 2, 1, "ul", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.downloaderService.isDownloading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.downloaderService.isSuccess);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.downloaderService.isError);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.listVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.listVisible);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r0.faTimes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.downloaderService.hasItems && ctx_r0.listVisible);
} }
const _c34 = [[["", "app-nav-menu", ""]], [["", "app-header", ""]], [["", "app-footer-right", ""]]];
const _c35 = ["[app-nav-menu]", "[app-header]", "[app-footer-right]"];
const _c36 = [[["", "app-footer-right", ""]]];
const _c37 = ["[app-footer-right]"];
let BadgeListComponent = class BadgeListComponent {
    constructor() {
        this.items = [];
        this.remove = new EventEmitter();
    }
    removeItem(id) {
        this.remove.emit(id);
    }
};
BadgeListComponent.ɵfac = function BadgeListComponent_Factory(t) { return new (t || BadgeListComponent)(); };
BadgeListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BadgeListComponent, selectors: [["badge-list"]], inputs: { items: "items", label: "label" }, outputs: { remove: "remove" }, decls: 1, vars: 1, consts: [["class", "form-group form-input-group", 4, "ngIf"], [1, "form-group", "form-input-group"], ["class", "form-input-label", 4, "ngIf"], [1, "badge-list", "d-flex", "flex-row", "flex-wrap"], ["class", "badge badge-pill badge-light", 4, "ngFor", "ngForOf"], [1, "form-input-label"], [1, "badge", "badge-pill", "badge-light"], ["href", "javascript:;", 3, "click", 4, "ngIf"], ["href", "javascript:;", 3, "click"]], template: function BadgeListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BadgeListComponent_div_0_Template, 4, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.items.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", String)
], BadgeListComponent.prototype, "label", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], BadgeListComponent.prototype, "items", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], BadgeListComponent.prototype, "remove", void 0);

let BaloonComponent = class BaloonComponent {
    constructor() {
    }
    get styles() {
        let styles = {};
        if (!isNullOrUndefined(this.color)) {
            styles = {
                backgroundColor: this.color
            };
        }
        return styles;
    }
};
BaloonComponent.ɵfac = function BaloonComponent_Factory(t) { return new (t || BaloonComponent)(); };
BaloonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BaloonComponent, selectors: [["baloon"]], inputs: { content: "content", color: "color" }, decls: 2, vars: 2, consts: [[1, "baloon", 3, "ngStyle"]], template: function BaloonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ctx.styles);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.content);
    } }, directives: [ɵngcc1.NgStyle], styles: [".baloon[_ngcontent-%COMP%]{height:30px;width:30px;border-radius:50%;color:#fff;padding:6px;cursor:pointer;text-align:center}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], BaloonComponent.prototype, "content", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BaloonComponent.prototype, "color", void 0);
BaloonComponent = __decorate([ __metadata("design:paramtypes", [])
], BaloonComponent);

let ButtonComponent = class ButtonComponent {
    constructor() {
        this.variant = "DEFAULT" /* DEFAULT */;
        this.disabled = false;
        this.loading = false;
        this.faCircleNotch = faCircleNotch;
    }
    get classes() {
        return {
            'btn-success': this.variant === "SUCCESS" /* SUCCESS */,
            'btn-secondary': this.variant === "SECONDARY" /* SECONDARY */,
            'btn-danger': this.variant === "DANGER" /* DANGER */,
            'btn-default': this.variant === "DEFAULT" /* DEFAULT */
        };
    }
};
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["pwc-button"]], inputs: { variant: "variant", disabled: "disabled", loading: "loading" }, ngContentSelectors: _c0, decls: 3, vars: 3, consts: [["type", "button", 1, "btn", 3, "ngClass", "disabled"], ["class", "btn-loader", 3, "icon", "spin", 4, "ngIf"], [1, "btn-loader", 3, "icon", "spin"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, ButtonComponent_fa_icon_2_Template, 1, 2, "fa-icon", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.classes)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.FaIconComponent], styles: [".btn[_ngcontent-%COMP%]{position:relative}.btn-loader[_ngcontent-%COMP%]{position:absolute;right:1em;top:.4em}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], ButtonComponent.prototype, "variant", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ButtonComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ButtonComponent.prototype, "loading", void 0);
ButtonComponent = __decorate([ __metadata("design:paramtypes", [])
], ButtonComponent);

let CollapsableComponent = class CollapsableComponent {
    constructor() {
    }
    ngOnInit() {
    }
    toggle() {
        console.log('toggle');
        this.open = !this.open;
    }
};
CollapsableComponent.ɵfac = function CollapsableComponent_Factory(t) { return new (t || CollapsableComponent)(); };
CollapsableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CollapsableComponent, selectors: [["collapsable"]], inputs: { open: "open", title: "title" }, ngContentSelectors: _c0, decls: 3, vars: 2, consts: [["href", "javascript:;", 1, "collapsable-title", 3, "click"], [4, "ngIf"]], template: function CollapsableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵlistener("click", function CollapsableComponent_Template_a_click_0_listener() { return ctx.toggle(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, CollapsableComponent_2_Template, 1, 0, undefined, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.open);
    } }, directives: [ɵngcc1.NgIf], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", String)
], CollapsableComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], CollapsableComponent.prototype, "open", void 0);
CollapsableComponent = __decorate([ __metadata("design:paramtypes", [])
], CollapsableComponent);

let DataTableComponent = 
/**
 * Usage:
 * In template: <data-table #dataTable></data-table>
 * In component: @ViewChild('dataTable') dataTable: DataTableComponent<BaseModel>;
 */
class DataTableComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.dataSource = [];
        this.columns = [];
        this.customColumns = [];
        this.customColumnDefs = new QueryList();
        this.hoverable = true;
        this.loading$ = null;
        this.enableSelect = false;
        this.allSelected = false;
        this.select = new EventEmitter();
        this.selectAll = new EventEmitter();
        this.sort = new EventEmitter();
        this.internalCustomColumns = [];
        this.sortType = '';
        this.sortReverse = 0;
    }
    ngAfterViewChecked() {
        this.customColumnDefs.changes.subscribe(() => {
            this.customColumnDefs.forEach((col) => {
                if (!this.internalCustomColumns.filter((item) => item.name === col.name).length) {
                    this.table.addColumnDef(col);
                    this.internalCustomColumns.push(col);
                }
            });
            this.changeDetectorRef.detectChanges();
        });
    }
    get displayedColumns() {
        let displayedColumns = [];
        if (this.enableSelect) {
            displayedColumns.push('selected');
        }
        const sortable = this.columns.filter(value => value.sortable);
        if (!isNullOrUndefined(sortable) && sortable.length > 0) {
            this.sortType = sortable[0].field;
        }
        displayedColumns = displayedColumns.concat(this.columns.map((col) => col.field))
            .concat(this.customColumns.filter((colName) => this.internalCustomColumns.filter((item) => item.name === colName).length > 0));
        return displayedColumns;
    }
    selectVisibleRows() {
        this.selectAll.emit(this.allSelected);
    }
    selectRows(id) {
        this.select.emit(id);
    }
    getColumnStyle(column) {
        let style = {};
        if (!isNullOrUndefined(column.width)) {
            style = Object.assign(Object.assign({}, style), { width: column.width });
        }
        return style;
    }
    handleDoubleClick(column, row) {
        if (isNullOrUndefined(column.onDblClick)) {
            return;
        }
        column.onDblClick(row);
    }
    hasDblClickHandler(column) {
        return !isNullOrUndefined(column.onDblClick);
    }
    onSort($event) {
        this.sortType = $event.column;
        if ($event.direction === "" /* NONE */) {
            this.sortReverse = 0;
        }
        else if ($event.direction === 'asc') {
            this.sortReverse = 1;
        }
        else if ($event.direction === 'desc') {
            this.sortReverse = 2;
        }
        this.sort.emit($event);
    }
};
DataTableComponent.ɵfac = function DataTableComponent_Factory(t) { return new (t || DataTableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DataTableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DataTableComponent, selectors: [["data-table"]], viewQuery: function DataTableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(CdkTable, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.table = _t.first);
    } }, inputs: { dataSource: "dataSource", columns: "columns", customColumns: "customColumns", customColumnDefs: "customColumnDefs", hoverable: "hoverable", loading$: "loading$", enableSelect: "enableSelect", allSelected: "allSelected", detailRowTpl: "detailRowTpl" }, outputs: { select: "select", selectAll: "selectAll", sort: "sort" }, decls: 9, vars: 10, consts: [["href", "//maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css", "rel", "stylesheet"], ["cdk-table", "", 1, "table", "table-striped", "mb-0", 3, "dataSource", "ngClass"], ["cdkColumnDef", "selected", "sticky", "", 4, "ngIf"], [3, "cdkColumnDef", 4, "ngFor", "ngForOf"], ["cdk-header-row", "", 4, "cdkHeaderRowDef"], [4, "ngIf"], ["cdkColumnDef", "selected", "sticky", ""], ["cdk-header-cell", "", "scope", "col", "style", "width: 15px", 4, "cdkHeaderCellDef"], ["cdk-cell", "", 4, "cdkCellDef"], ["cdk-header-cell", "", "scope", "col", 2, "width", "15px"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", "id", "selectAllRowsCheckBox", "name", "selectAllRowsCheckBox", 1, "custom-control-input", 3, "ngModel", "change", "ngModelChange"], ["for", "selectAllRowsCheckBox", 1, "custom-control-label"], ["cdk-cell", ""], ["type", "checkbox", 1, "custom-control-input", 3, "checked", "ngModelOptions", "ngModel", "change"], [1, "custom-control-label"], [3, "cdkColumnDef"], ["cdk-header-cell", "", "scope", "col", 3, "ngStyle", "sortable", "sort", 4, "cdkHeaderCellDef"], ["cdk-header-cell", "", "scope", "col", 3, "ngStyle", "sortable", "sort"], ["class", "fa fa-sort-asc", 4, "ngIf"], ["class", "fa fa-sort-desc", 4, "ngIf"], ["class", "fa fa-sort", 4, "ngIf"], [1, "fa", "fa-sort-asc"], [1, "fa", "fa-sort-desc"], [1, "fa", "fa-sort"], ["cdk-header-cell", "", "scope", "col", 3, "ngStyle", 4, "cdkHeaderCellDef"], ["cdk-header-cell", "", "scope", "col", 3, "ngStyle"], ["cdk-cell", "", 3, "ngClass", "dblclick", 4, "cdkCellDef"], ["cdk-cell", "", 3, "ngClass", "dblclick"], ["cdk-cell", "", 3, "ngClass", "innerHTML", "dblclick", 4, "cdkCellDef"], ["cdk-cell", "", 3, "ngClass", "innerHTML", "dblclick"], ["cdk-header-row", ""], ["cdk-row", "", 4, "cdkRowDef", "cdkRowDefColumns"], ["cdk-row", ""], ["cdk-row", "", 3, "detailRow", "detailRowTpl", "expand", 4, "cdkRowDef", "cdkRowDefColumns"], ["cdk-row", "", 3, "detailRow", "detailRowTpl", "expand"], ["backgroundColor", "#ccc", 3, "viewBox", 4, "ngIf"], ["backgroundColor", "#ccc", 3, "viewBox"], ["x", "20", "y", "10", "rx", "3", "ry", "3", "width", "90%", "height", "10"], ["x", "20", "y", "30", "rx", "3", "ry", "3", "width", "90%", "height", "10"], ["x", "20", "y", "50", "rx", "3", "ry", "3", "width", "90%", "height", "10"], ["x", "20", "y", "70", "rx", "3", "ry", "3", "width", "90%", "height", "10"], ["x", "20", "y", "90", "rx", "3", "ry", "3", "width", "90%", "height", "10"]], template: function DataTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "link", 0);
        ɵngcc0.ɵɵelementStart(1, "table", 1);
        ɵngcc0.ɵɵtemplate(2, DataTableComponent_ng_container_2_Template, 3, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, DataTableComponent_ng_container_3_Template, 5, 5, "ng-container", 3);
        ɵngcc0.ɵɵelementContainer(4);
        ɵngcc0.ɵɵtemplate(5, DataTableComponent_tr_5_Template, 1, 0, "tr", 4);
        ɵngcc0.ɵɵtemplate(6, DataTableComponent_ng_container_6_Template, 2, 1, "ng-container", 5);
        ɵngcc0.ɵɵtemplate(7, DataTableComponent_ng_container_7_Template, 2, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DataTableComponent_ng_container_8_Template, 3, 3, "ng-container", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("dataSource", ctx.dataSource)("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c3, ctx.hoverable));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableSelect);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.columns);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdkHeaderRowDef", ctx.displayedColumns);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.detailRowTpl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.detailRowTpl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading$ != null);
    } }, directives: function () { return [ɵngcc3.CdkTable, ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc3.CdkHeaderRowDef, ɵngcc3.CdkColumnDef, ɵngcc3.CdkHeaderCellDef, ɵngcc3.CdkCellDef, ɵngcc3.CdkHeaderCell, ɵngcc4.CheckboxControlValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc3.CdkCell, NgbdSortableHeaderDirective, ɵngcc1.NgStyle, ɵngcc3.CdkHeaderRow, ɵngcc3.CdkRowDef, ɵngcc3.CdkRow, DetailRowDirective, ɵngcc5.ContentLoaderComponent]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: [""] });
DataTableComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input(),
    __metadata("design:type", Array)
], DataTableComponent.prototype, "dataSource", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], DataTableComponent.prototype, "columns", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], DataTableComponent.prototype, "customColumns", void 0);
__decorate([
    Input(),
    __metadata("design:type", QueryList)
], DataTableComponent.prototype, "customColumnDefs", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], DataTableComponent.prototype, "detailRowTpl", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], DataTableComponent.prototype, "hoverable", void 0);
__decorate([
    Input(),
    __metadata("design:type", Observable)
], DataTableComponent.prototype, "loading$", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], DataTableComponent.prototype, "enableSelect", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], DataTableComponent.prototype, "allSelected", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DataTableComponent.prototype, "select", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DataTableComponent.prototype, "selectAll", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DataTableComponent.prototype, "sort", void 0);
__decorate([
    ViewChild(CdkTable, { static: true }),
    __metadata("design:type", CdkTable)
], DataTableComponent.prototype, "table", void 0);
DataTableComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
], DataTableComponent);

let ListToolbarComponent = class ListToolbarComponent {
};
ListToolbarComponent.ɵfac = function ListToolbarComponent_Factory(t) { return new (t || ListToolbarComponent)(); };
ListToolbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListToolbarComponent, selectors: [["list-toolbar"]], ngContentSelectors: _c5, decls: 7, vars: 0, consts: [[1, "card", "toolbar-card", "mb-3", 2, "width", "100%"], [1, "card-body", "card-table"], [1, "d-flex", "p-2"], [1, "m-2", "pr-2", "toolbar-box-border-right"], [1, "m-2", "align-self-center"]], template: function ListToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c4);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });

class AlertModal {
    constructor(id, type, message) {
        this.id = id;
        this.type = type;
        this.message = message;
    }
}

let AlertComponent = class AlertComponent {
    constructor(ngxSmartModalService) {
        this.ngxSmartModalService = ngxSmartModalService;
        this.onAnyCloseEmitter = new EventEmitter();
    }
    ngOnInit() {
        this.type = '';
    }
    openModalAlert(id, type, message) {
        console.log('ALERT:', id, type, message);
        const obj = new AlertModal(id, type, message);
        this.type = obj.type;
        this.ngxSmartModalService.setModalData(obj, 'confirmationModal', true);
        this.ngxSmartModalService.getModal('confirmationModal').open();
    }
    onAnyClose(e) {
        console.log('close alert');
        this.onAnyCloseEmitter.emit(this.type);
    }
};
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.NgxSmartModalService)); };
AlertComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["alert"]], inputs: { model: "model" }, outputs: { onAnyCloseEmitter: "onAnyCloseEmitter" }, decls: 3, vars: 1, consts: [["identifier", "alertModal", "customClass", "nsm-dialog-animation-ttb medium-modal", 3, "onAnyCloseEvent"], ["alertModal", ""], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ngx-smart-modal", 0, 1);
        ɵngcc0.ɵɵlistener("onAnyCloseEvent", function AlertComponent_Template_ngx_smart_modal_onAnyCloseEvent_0_listener($event) { return ctx.onAnyClose($event); });
        ɵngcc0.ɵɵtemplate(2, AlertComponent_h5_2_Template, 1, 1, "h5", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", _r0.hasData());
    } }, directives: [ɵngcc6.NgxSmartModalComponent, ɵngcc1.NgIf], styles: [""] });
AlertComponent.ctorParameters = () => [
    { type: NgxSmartModalService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], AlertComponent.prototype, "model", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], AlertComponent.prototype, "onAnyCloseEmitter", void 0);
AlertComponent = __decorate([ __metadata("design:paramtypes", [NgxSmartModalService])
], AlertComponent);

let ModalComponent = class ModalComponent {
    constructor(ngxSmartModalService) {
        this.ngxSmartModalService = ngxSmartModalService;
        this.bodyPadding = true;
        this.showFooter = true;
        this.closable = true;
        this.dismissable = true;
        this.boolean = true;
        // Emits this modal's id on open.
        this.opened = new EventEmitter();
        // Emits this modal's id on close.
        this.closed = new EventEmitter();
    }
    get bodyClass() {
        let cssClass = '';
        if (this.bodyPadding) {
            cssClass += 'modal-body';
        }
        return cssClass;
    }
    open() {
        this.ngxSmartModalService.getModal(this.id).open();
        this.opened.emit(this.id);
    }
    close() {
        this.ngxSmartModalService.getModal(this.id).close();
        // this.onClose();
    }
    onClose() {
        this.closed.emit(this.id);
    }
};
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.NgxSmartModalService)); };
ModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["pwc-modal"]], inputs: { bodyPadding: "bodyPadding", showFooter: "showFooter", closable: "closable", dismissable: "dismissable", id: "id", escapable: "escapable" }, outputs: { opened: "opened", closed: "closed" }, ngContentSelectors: _c7, decls: 7, vars: 7, consts: [["customClass", "modal-content p-0", "force", "false", 3, "identifier", "id", "closable", "dismissable", "escapable", "onClose"], [1, "modal-header"], [1, "modal-title", "text-uppercase"], [3, "ngClass"], ["class", "modal-footer", 4, "ngIf"], [1, "modal-footer"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c6);
        ɵngcc0.ɵɵelementStart(0, "ngx-smart-modal", 0);
        ɵngcc0.ɵɵlistener("onClose", function ModalComponent_Template_ngx_smart_modal_onClose_0_listener() { return ctx.onClose(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h5", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵprojection(5, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, ModalComponent_div_6_Template, 2, 0, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("identifier", ctx.id)("id", ctx.id)("closable", ctx.closable)("dismissable", ctx.dismissable)("escapable", ctx.escapable);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ctx.bodyClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFooter);
    } }, directives: [ɵngcc6.NgxSmartModalComponent, ɵngcc1.NgClass, ɵngcc1.NgIf], styles: [""] });
ModalComponent.ctorParameters = () => [
    { type: NgxSmartModalService }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], ModalComponent.prototype, "id", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ModalComponent.prototype, "bodyPadding", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ModalComponent.prototype, "showFooter", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ModalComponent.prototype, "closable", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ModalComponent.prototype, "dismissable", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ModalComponent.prototype, "escapable", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ModalComponent.prototype, "opened", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ModalComponent.prototype, "closed", void 0);
ModalComponent = __decorate([ __metadata("design:paramtypes", [NgxSmartModalService])
], ModalComponent);

let ConfirmationModalComponent = class ConfirmationModalComponent {
    constructor() {
        this.id = 'confirmationModal';
        this.title = 'confirm-modal.title';
        this.message = 'confirm-modal.delete-msg';
        this.positiveButtonText = 'actions.confirm';
        this.negativeButtonText = 'actions.cancel';
        this.closed = new EventEmitter();
        this.positiveButtonClick = new EventEmitter();
        this.negativeButtonClick = new EventEmitter();
    }
    open(payload = null) {
        this.payload = payload;
        this.confirmationModal.open();
    }
    onClose() {
        this.closed.emit(this.payload);
    }
    onPositiveClick() {
        this.confirmationModal.close();
        this.positiveButtonClick.emit(this.payload);
    }
    onNegativeClick() {
        this.confirmationModal.close();
        this.negativeButtonClick.emit(this.payload);
    }
};
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(); };
ConfirmationModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["pwc-confirmation-modal"]], viewQuery: function ConfirmationModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c8, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.confirmationModal = _t.first);
    } }, inputs: { id: "id", title: "title", message: "message", positiveButtonText: "positiveButtonText", negativeButtonText: "negativeButtonText" }, outputs: { closed: "closed", positiveButtonClick: "positiveButtonClick", negativeButtonClick: "negativeButtonClick" }, decls: 13, vars: 9, consts: [[3, "id", "closed"], ["confirmationModal", ""], ["modal-title", ""], ["modal-body", ""], [1, "row"], [1, "col-md-12"], ["modal-footer", "", 1, "text-right"], ["type", "button", "class", "btn btn-action btn-danger", "data-dismiss", "modal", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn btn-action btn-success ml-2", 3, "click", 4, "ngIf"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-action", "btn-danger", 3, "click"], ["type", "button", 1, "btn", "btn-action", "btn-success", "ml-2", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "pwc-modal", 0, 1);
        ɵngcc0.ɵɵlistener("closed", function ConfirmationModalComponent_Template_pwc_modal_closed_0_listener() { return ctx.onClose(); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵtemplate(11, ConfirmationModalComponent_button_11_Template, 3, 3, "button", 7);
        ɵngcc0.ɵɵtemplate(12, ConfirmationModalComponent_button_12_Template, 3, 3, "button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 5, ctx.title), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 7, ctx.message), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.negativeButtonText !== "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.positiveButtonText !== "");
    } }, directives: [ModalComponent, ɵngcc1.NgIf], pipes: [ɵngcc7.TranslatePipe], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], ConfirmationModalComponent.prototype, "id", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ConfirmationModalComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ConfirmationModalComponent.prototype, "message", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ConfirmationModalComponent.prototype, "positiveButtonText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ConfirmationModalComponent.prototype, "negativeButtonText", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ConfirmationModalComponent.prototype, "closed", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ConfirmationModalComponent.prototype, "positiveButtonClick", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ConfirmationModalComponent.prototype, "negativeButtonClick", void 0);
__decorate([
    ViewChild('confirmationModal', { static: true }),
    __metadata("design:type", ModalComponent)
], ConfirmationModalComponent.prototype, "confirmationModal", void 0);

let SortingArrowsComponent = class SortingArrowsComponent {
    constructor() {
        this.selected = false;
        this.direction = 0;
    }
};
SortingArrowsComponent.ɵfac = function SortingArrowsComponent_Factory(t) { return new (t || SortingArrowsComponent)(); };
SortingArrowsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SortingArrowsComponent, selectors: [["pwc-sorting-arrows"]], inputs: { selected: "selected", direction: "direction" }, decls: 3, vars: 3, consts: [["class", "fa fa-sort-asc", 4, "ngIf"], ["class", "fa fa-sort-desc", 4, "ngIf"], ["class", "fa fa-sort", 4, "ngIf"], [1, "fa", "fa-sort-asc"], [1, "fa", "fa-sort-desc"], [1, "fa", "fa-sort"]], template: function SortingArrowsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SortingArrowsComponent_span_0_Template, 1, 0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, SortingArrowsComponent_span_1_Template, 1, 0, "span", 1);
        ɵngcc0.ɵɵtemplate(2, SortingArrowsComponent_span_2_Template, 1, 0, "span", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.selected && ctx.direction == 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selected && ctx.direction == 2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selected && ctx.direction == 0 || !ctx.selected);
    } }, directives: [ɵngcc1.NgIf], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], SortingArrowsComponent.prototype, "selected", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], SortingArrowsComponent.prototype, "direction", void 0);

let DetailRowDirective = class DetailRowDirective {
    constructor(vcRef) {
        this.vcRef = vcRef;
    }
    get expanded() {
        return this.opened;
    }
    set detailRow(value) {
        if (value !== this.row) {
            this.row = value;
        }
    }
    set template(value) {
        if (value !== this.tRef) {
            this.tRef = value;
        }
    }
    set expand(value) {
        if (value !== this.opened) {
            this.toggle();
        }
    }
    toggle() {
        if (this.opened) {
            this.vcRef.clear();
        }
        else {
            this.render();
        }
        this.opened = this.vcRef.length > 0;
    }
    render() {
        this.vcRef.clear();
        if (this.tRef && this.row) {
            this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
        }
    }
};
DetailRowDirective.ɵfac = function DetailRowDirective_Factory(t) { return new (t || DetailRowDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
DetailRowDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DetailRowDirective, selectors: [["", "detailRow", ""]], hostVars: 2, hostBindings: function DetailRowDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("expanded", ctx.expanded);
    } }, inputs: { detailRow: "detailRow", template: ["detailRowTpl", "template"], expand: "expand" } });
DetailRowDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
__decorate([
    HostBinding('class.expanded'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DetailRowDirective.prototype, "expanded", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DetailRowDirective.prototype, "detailRow", null);
__decorate([
    Input('detailRowTpl'),
    __metadata("design:type", TemplateRef),
    __metadata("design:paramtypes", [TemplateRef])
], DetailRowDirective.prototype, "template", null);
__decorate([
    Input('expand'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], DetailRowDirective.prototype, "expand", null);
DetailRowDirective = __decorate([ __metadata("design:paramtypes", [ViewContainerRef])
], DetailRowDirective);

const rotate = { 'asc': 'desc', 'desc': '', '': 'asc' };
let NgbdSortableHeaderDirective = class NgbdSortableHeaderDirective {
    constructor() {
        this.direction = '';
        this.sort = new EventEmitter();
    }
    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.sortable, direction: this.direction });
    }
};
NgbdSortableHeaderDirective.ɵfac = function NgbdSortableHeaderDirective_Factory(t) { return new (t || NgbdSortableHeaderDirective)(); };
NgbdSortableHeaderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgbdSortableHeaderDirective, selectors: [["th", "sortable", ""]], hostVars: 6, hostBindings: function NgbdSortableHeaderDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NgbdSortableHeaderDirective_click_HostBindingHandler() { return ctx.rotate(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("sortable", true)("asc", ctx.direction === "asc")("desc", ctx.direction === "desc");
    } }, inputs: { direction: "direction", sortable: "sortable" }, outputs: { sort: "sort" } });
__decorate([
    Input(),
    __metadata("design:type", String)
], NgbdSortableHeaderDirective.prototype, "sortable", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NgbdSortableHeaderDirective.prototype, "direction", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], NgbdSortableHeaderDirective.prototype, "sort", void 0);

let UIDirectivesModule = class UIDirectivesModule {
};
UIDirectivesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: UIDirectivesModule });
UIDirectivesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function UIDirectivesModule_Factory(t) { return new (t || UIDirectivesModule)(); }, imports: [[
            CommonModule
        ]] });

/**
 * A configuration service for the Pagination component.
 *
 * You can inject this service, typically in your root component, and customize the values of its properties in order to provide default
 * values for all the paginations used in the application.
 */
let PaginationConfig = class PaginationConfig extends NgbPaginationConfig {
};
PaginationConfig.ɵfac = function PaginationConfig_Factory(t) { return ɵPaginationConfig_BaseFactory(t || PaginationConfig); };
PaginationConfig.ɵprov = ɵɵdefineInjectable({ factory: function PaginationConfig_Factory() { return new PaginationConfig(); }, token: PaginationConfig, providedIn: "root" });

function getValueInRange(value, max, min = 0) {
    return Math.max(Math.min(value, max), min);
}
function isNumber(value) {
    return !isNaN(toInteger(value));
}
function toInteger(value) {
    return parseInt(`${value}`, 10);
}

let PaginationComponent = class PaginationComponent {
    constructor(config) {
        this.pageCount = 0;
        this.pages = [];
        this.faAngleLeft = faAngleLeft;
        this.faAngleRight = faAngleRight;
        /**
         * Whether to to show collectionSize
         *
         * Defaults to true
         */
        this.showCollectionSize = true;
        /**
         * The current page.
         *
         * Page numbers start with `1`.
         */
        this.page = 1;
        /**
         * An event fired when the page is changed. Will fire only if collection size is set and all values are valid.
         *
         * Event payload is the number of the newly selected page.
         * Page numbers start with `1`.
         */
        this.pageChange = new EventEmitter(true);
        this.disabled = config.disabled;
        this.boundaryLinks = config.boundaryLinks;
        this.directionLinks = config.directionLinks;
        this.ellipses = config.ellipses;
        this.maxSize = config.maxSize;
        this.pageSize = config.pageSize;
        this.rotate = config.rotate;
        this.size = config.size;
    }
    hasPrevious() {
        return this.page > 1;
    }
    hasNext() {
        return this.page < this.pageCount;
    }
    nextDisabled() {
        return this.disabled || !this.hasNext();
    }
    previousDisabled() {
        return this.disabled || !this.hasPrevious();
    }
    selectPage(pageNumber) {
        this.updatePages(pageNumber);
    }
    ngOnChanges(changes) {
        this.tmpPage = this.page;
        this.updatePages(this.page);
    }
    isEllipsis(pageNumber) {
        return pageNumber === -1;
    }
    /**
     * Appends ellipses and first/last page number to the displayed pages.
     */
    applyEllipses(start, end) {
        if (!this.ellipses) {
            return;
        }
        if (start > 1) {
            this.pages.unshift(-1);
        }
        if (start > 0) {
            this.pages.unshift(1);
        }
        if (end < (this.pageCount - 1)) {
            this.pages.push(-1);
        }
        if (end < this.pageCount) {
            this.pages.push(this.pageCount);
        }
    }
    /**
     * Rotates page numbers based on maxSize items visible.
     * Currently selected page stays in the middle.
     *
     * Ex. for selected page = 6;
     * [5,*6*,7] for maxSize = 3
     * [4,5,*6*,7] for maxSize = 4
     */
    applyRotation() {
        let start = 0;
        let end = this.pageCount;
        const leftOffset = Math.floor(this.maxSize / 2);
        const rightOffset = this.maxSize % 2 === 0 ? leftOffset - 1 : leftOffset;
        if (this.page <= leftOffset) {
            // Very beginning, no rotation -> [0..maxSize]
            end = this.maxSize;
        }
        else if (this.pageCount - this.page < leftOffset) {
            // Very end, no rotation -> [len-maxSize..len]
            start = this.pageCount - this.maxSize;
        }
        else {
            // Rotate
            start = this.page - leftOffset - 1;
            end = this.page + rightOffset;
        }
        return [start, end];
    }
    /**
     * Paginates page numbers based on maxSize items per page.
     */
    applyPagination() {
        const page = Math.ceil(this.page / this.maxSize) - 1;
        const start = page * this.maxSize;
        const end = start + this.maxSize;
        return [start, end];
    }
    setPageInRange(newPageNo) {
        const prevPageNo = this.page;
        this.page = getValueInRange(newPageNo, this.pageCount, 1);
        console.debug('newPageNo', newPageNo);
        console.debug('page', this.page);
        if (this.page !== prevPageNo && isNumber(this.collectionSize)) {
            this.pageChange.emit(this.page);
        }
    }
    updatePages(newPage) {
        this.pageCount = Math.ceil(this.collectionSize / this.pageSize);
        if (!isNumber(this.pageCount)) {
            this.pageCount = 0;
        }
        // fill-in model needed to render pages.
        this.pages.length = 0;
        for (let i = 1; i <= this.pageCount; i++) {
            this.pages.push(i);
        }
        // Set page within 1..max range
        this.setPageInRange(newPage);
        // Apply maxSize if necessary.
        if (this.maxSize > 0 && this.pageCount > this.maxSize) {
            let start = 0;
            let end = this.pageCount;
            // Either paginating or rotating page numbers
            if (this.rotate) {
                [start, end] = this.applyRotation();
            }
            else {
                [start, end] = this.applyPagination();
            }
            this.pages = this.pages.slice(start, end);
            // Adding ellipses
            this.applyEllipses(start, end);
            this.tmpPage = this.page;
        }
    }
    applyPageChange() {
        setTimeout(() => {
            this.tmpPage = getValueInRange(this.tmpPage, this.pageCount, 1);
            this.selectPage(this.tmpPage);
        }, 100);
    }
    resetPageChange() {
        setTimeout(() => {
            this.tmpPage = this.page;
        }, 100);
    }
};
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(ɵngcc0.ɵɵdirectiveInject(PaginationConfig)); };
PaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["pwc-pagination"]], contentQueries: function PaginationComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgbPaginationEllipsis, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgbPaginationFirst, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgbPaginationLast, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgbPaginationNext, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgbPaginationNumber, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgbPaginationPrevious, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tplEllipsis = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tplFirst = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tplLast = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tplNext = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tplNumber = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tplPrevious = _t.first);
    } }, inputs: { showCollectionSize: "showCollectionSize", page: "page", disabled: "disabled", boundaryLinks: "boundaryLinks", directionLinks: "directionLinks", ellipses: "ellipses", maxSize: "maxSize", pageSize: "pageSize", rotate: "rotate", size: "size", collectionSize: "collectionSize" }, outputs: { pageChange: "pageChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 24, vars: 9, consts: [["first", ""], ["previous", ""], ["next", ""], ["last", ""], ["ellipsis", ""], ["defaultNumber", ""], ["class", "page-item", 3, "disabled", 4, "ngIf"], [1, "page-item", "page-number-selector"], [1, "form-group", "form-input-group"], ["type", "number", "id", "page-number", 1, "form-control", "form-input", "page-number-input", 3, "ngModel", "ngModelChange", "keyup.enter", "blur"], [1, "page-item", "disabled"], [1, "page-link"], ["class", "page-item ml-4 d-flex flex-row align-items-center", 4, "ngIf"], ["aria-hidden", "true"], [3, "icon"], ["class", "sr-only", 4, "ngIf"], [1, "sr-only"], [1, "page-item"], ["href", "", 1, "page-link", 3, "click", 6, "aria-label"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "page-item", "ml-4", "d-flex", "flex-row", "align-items-center"], ["translate", "", 1, "mr-2"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PaginationComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, PaginationComponent_ng_template_2_Template, 3, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, PaginationComponent_ng_template_4_Template, 3, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, PaginationComponent_ng_template_6_Template, 2, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, PaginationComponent_ng_template_8_Template, 1, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, PaginationComponent_ng_template_10_Template, 2, 2, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(12, "ul");
        ɵngcc0.ɵɵtemplate(13, PaginationComponent_li_13_Template, 4, 8, "li", 6);
        ɵngcc0.ɵɵtemplate(14, PaginationComponent_li_14_Template, 4, 7, "li", 6);
        ɵngcc0.ɵɵelementStart(15, "li", 7);
        ɵngcc0.ɵɵelementStart(16, "div", 8);
        ɵngcc0.ɵɵelementStart(17, "input", 9);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaginationComponent_Template_input_ngModelChange_17_listener($event) { return ctx.tmpPage = $event; })("keyup.enter", function PaginationComponent_Template_input_keyup_enter_17_listener() { return ctx.applyPageChange(); })("blur", function PaginationComponent_Template_input_blur_17_listener() { return ctx.resetPageChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "li", 10);
        ɵngcc0.ɵɵelementStart(19, "a", 11);
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(21, PaginationComponent_li_21_Template, 4, 8, "li", 6);
        ɵngcc0.ɵɵtemplate(22, PaginationComponent_li_22_Template, 4, 8, "li", 6);
        ɵngcc0.ɵɵtemplate(23, PaginationComponent_li_23_Template, 5, 1, "li", 12);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(12);
        ɵngcc0.ɵɵclassMap("pagination" + (ctx.size ? " pagination-" + ctx.size : ""));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.boundaryLinks);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.directionLinks);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.tmpPage);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" di ", ctx.pageCount, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.directionLinks);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.boundaryLinks);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCollectionSize);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NumberValueAccessor, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc2.FaIconComponent, ɵngcc1.NgTemplateOutlet, ɵngcc7.TranslateDirective], styles: [""] });
PaginationComponent.ctorParameters = () => [
    { type: PaginationConfig }
];
__decorate([
    ContentChild(NgbPaginationEllipsis),
    __metadata("design:type", NgbPaginationEllipsis)
], PaginationComponent.prototype, "tplEllipsis", void 0);
__decorate([
    ContentChild(NgbPaginationFirst),
    __metadata("design:type", NgbPaginationFirst)
], PaginationComponent.prototype, "tplFirst", void 0);
__decorate([
    ContentChild(NgbPaginationLast),
    __metadata("design:type", NgbPaginationLast)
], PaginationComponent.prototype, "tplLast", void 0);
__decorate([
    ContentChild(NgbPaginationNext),
    __metadata("design:type", NgbPaginationNext)
], PaginationComponent.prototype, "tplNext", void 0);
__decorate([
    ContentChild(NgbPaginationNumber),
    __metadata("design:type", NgbPaginationNumber)
], PaginationComponent.prototype, "tplNumber", void 0);
__decorate([
    ContentChild(NgbPaginationPrevious),
    __metadata("design:type", NgbPaginationPrevious)
], PaginationComponent.prototype, "tplPrevious", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "boundaryLinks", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "directionLinks", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "ellipses", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "rotate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PaginationComponent.prototype, "collectionSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PaginationComponent.prototype, "showCollectionSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PaginationComponent.prototype, "maxSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PaginationComponent.prototype, "page", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PaginationComponent.prototype, "pageSize", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], PaginationComponent.prototype, "pageChange", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PaginationComponent.prototype, "size", void 0);
PaginationComponent = __decorate([ __metadata("design:paramtypes", [PaginationConfig])
], PaginationComponent);

let BreadcrumbsComponent = class BreadcrumbsComponent {
    constructor() {
        this.items = [];
        this.fullWidth = false;
        this.homeItem = {
            label: 'Home',
            url: '/'
        };
    }
    getBreadcrumbClass() {
        if (this.fullWidth) {
            return 'breadcrumb-full-width';
        }
        else {
            return 'breadcrumb';
        }
    }
    getBreadcrumbWrapperClass() {
        if (this.fullWidth) {
            return 'breadcrumb-full-width-wrapper';
        }
        else {
            return 'breadcrumb-wrapper';
        }
    }
};
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(); };
BreadcrumbsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["pwc-breadcrumbs"]], inputs: { items: "items", fullWidth: "fullWidth" }, decls: 6, vars: 4, consts: [["aria-label", "breadcrumb", 3, "ngClass"], [1, "breadcrumb-prefix"], [3, "routerLink"], ["src", "/assets/images/icons/docs-home.svg", "alt", "Home"], [3, "ngClass"], ["class", "breadcrumb-item", 4, "ngFor", "ngForOf"], [1, "breadcrumb-item"]], template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "a", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ol", 4);
        ɵngcc0.ɵɵtemplate(5, BreadcrumbsComponent_li_5_Template, 3, 2, "li", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.getBreadcrumbWrapperClass());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("routerLink", ctx.homeItem.url);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.getBreadcrumbClass());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [ɵngcc1.NgClass, ɵngcc8.RouterLinkWithHref, ɵngcc1.NgForOf], styles: [".breadcrumb[_ngcontent-%COMP%]{display:inline-block;height:40px;min-width:800px;max-width:calc(100% - 80px);margin-bottom:0;padding-left:.5rem;padding-right:.5rem;background-color:#fff}.breadcrumb-wrapper[_ngcontent-%COMP%]{margin-bottom:1rem}.breadcrumb[_ngcontent-%COMP%], .breadcrumb-postfix[_ngcontent-%COMP%], .breadcrumb-prefix[_ngcontent-%COMP%]{vertical-align:middle}.breadcrumb-postfix[_ngcontent-%COMP%], .breadcrumb-prefix[_ngcontent-%COMP%]{display:inline-block;height:40px;width:40px;text-align:center;background-color:#eaebea}.breadcrumb-postfix[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .breadcrumb-prefix[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;padding:11px}.breadcrumb-item[_ngcontent-%COMP%]{display:inline-block;line-height:40px}.breadcrumb-full-width[_ngcontent-%COMP%]{display:inline-block;height:40px;min-width:800px;width:100%;margin-bottom:0;padding-left:.5rem;padding-right:.5rem;background-color:#fff}.breadcrumb-full-width-wrapper[_ngcontent-%COMP%]{margin-bottom:1rem;display:flex}.breadcrumb-full-width[_ngcontent-%COMP%], .breadcrumb-full-width-postfix[_ngcontent-%COMP%], .breadcrumb-full-width-prefix[_ngcontent-%COMP%]{vertical-align:middle}.breadcrumb-full-width-postfix[_ngcontent-%COMP%], .breadcrumb-full-width-prefix[_ngcontent-%COMP%]{display:inline-block;height:40px;width:40px;text-align:center;background-color:#eaebea}.breadcrumb-full-width-postfix[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .breadcrumb-full-width-prefix[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;padding:11px}.breadcrumb-full-width-item[_ngcontent-%COMP%]{display:inline-block;line-height:40px}"] });
__decorate([
    Input(),
    __metadata("design:type", Array)
], BreadcrumbsComponent.prototype, "items", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], BreadcrumbsComponent.prototype, "fullWidth", void 0);

let PageSizeSelectorComponent = class PageSizeSelectorComponent {
    constructor() {
        this.options = [{ value: 10 }, { value: 20 }, { value: 50 }];
        this.pageSizeChange = new EventEmitter();
    }
};
PageSizeSelectorComponent.ɵfac = function PageSizeSelectorComponent_Factory(t) { return new (t || PageSizeSelectorComponent)(); };
PageSizeSelectorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PageSizeSelectorComponent, selectors: [["pwc-page-size-selector"]], inputs: { options: "options", pageSize: "pageSize" }, outputs: { pageSizeChange: "pageSizeChange" }, decls: 2, vars: 4, consts: [["name", "pageSize", "autofocus", "false", "bindValue", "value", 1, "custom", 2, "width", "auto", 3, "ngModel", "clearable", "searchable", "change"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function PageSizeSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ng-select", 0);
        ɵngcc0.ɵɵlistener("change", function PageSizeSelectorComponent_Template_ng_select_change_0_listener($event) { return ctx.pageSizeChange.emit($event); });
        ɵngcc0.ɵɵtemplate(1, PageSizeSelectorComponent_ng_option_1_Template, 3, 7, "ng-option", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.pageSize)("clearable", false)("searchable", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.options);
    } }, directives: [ɵngcc9.NgSelectComponent, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc1.NgForOf, ɵngcc9.ɵr], pipes: [ɵngcc7.TranslatePipe], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Number)
], PageSizeSelectorComponent.prototype, "pageSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], PageSizeSelectorComponent.prototype, "options", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], PageSizeSelectorComponent.prototype, "pageSizeChange", void 0);

let DownloaderQueueComponent = class DownloaderQueueComponent {
    constructor(downloaderService, domSanitizer) {
        this.downloaderService = downloaderService;
        this.domSanitizer = domSanitizer;
        this.listVisible = false;
        this.faCircleNotch = faCircleNotch;
        this.faTimesCircle = faTimesCircle;
        this.faCheckCircle = faCheckCircle;
        this.faTimes = faTimes;
        this.faAngleDown = faAngleDown;
        this.faAngleUp = faAngleUp;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.downloaderService.onDownloadCompleted.subscribe((item) => {
            this.openFile(item);
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions == null) {
            return;
        }
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    openFile(item) {
        if (item.url == null) {
            return;
        }
        // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        if (window.navigator.msSaveBlob) {
            window.navigator.msSaveOrOpenBlob(item.blob, item.fileName);
        }
        else {
            this.downloadUrl = URL.createObjectURL(new Blob([item.blob]));
            this.downloadName = item.fileName;
            setTimeout(() => {
                this.downloadElement.nativeElement.click();
                setTimeout(() => {
                    //  For Firefox it is necessary to delay revoking the ObjectURL.
                    URL.revokeObjectURL(this.downloadUrl);
                    this.downloadUrl = null;
                    this.downloadName = null;
                }, 100);
            }, 100);
        }
    }
    sanitizeUrl(url) {
        if (url == null) {
            return null;
        }
        return this.domSanitizer.bypassSecurityTrustUrl(url);
    }
    hideList() {
        this.listVisible = false;
    }
    showList() {
        this.listVisible = true;
    }
    closeDialog() {
        if (this.downloaderService.isSuccess || this.downloaderService.isError) {
            this.emptyQueue();
        }
        this.hideList();
    }
    emptyQueue() {
        this.downloaderService.removeAll();
    }
};
DownloaderQueueComponent.ɵfac = function DownloaderQueueComponent_Factory(t) { return new (t || DownloaderQueueComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc10.DownloaderService), ɵngcc0.ɵɵdirectiveInject(ɵngcc11.DomSanitizer)); };
DownloaderQueueComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DownloaderQueueComponent, selectors: [["pwc-downloader-queue"]], viewQuery: function DownloaderQueueComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c32, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.downloadElement = _t.first);
    } }, decls: 3, vars: 3, consts: [["class", "downloader-queue", 4, "ngIf"], ["target", "_blank", 2, "display", "none!important", 3, "href", "download"], ["download", ""], [1, "downloader-queue"], [1, "downloader-queue-header", "d-flex", "justify-content-between"], [2, "line-height", "22px"], ["translate", "", 4, "ngIf"], [1, "downloader-queue-actions"], ["class", "btn btn-sm", "type", "button", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-sm", 3, "click"], [3, "icon"], ["class", "downloader-queue-file-list", 4, "ngIf"], ["translate", ""], [1, "downloader-queue-file-list"], ["class", "downloader-queue-file d-flex justify-content-between", 4, "ngFor", "ngForOf"], [1, "downloader-queue-file", "d-flex", "justify-content-between"], [1, "file-name", 3, "ngClass"], [1, "downloader-queue-icon"], [3, "icon", "spin", 4, "ngIf"], ["class", "text-danger", 3, "icon", 4, "ngIf"], ["href", "javascript:;", 3, "click"], ["class", "text-success", 3, "icon", 4, "ngIf"], [3, "icon", "spin"], [1, "text-danger", 3, "icon"], [1, "text-success", 3, "icon"]], template: function DownloaderQueueComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DownloaderQueueComponent_div_0_Template, 12, 7, "div", 0);
        ɵngcc0.ɵɵelement(1, "a", 1, 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.downloaderService.isNotEmpty());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("href", ctx.sanitizeUrl(ctx.downloadUrl), ɵngcc0.ɵɵsanitizeUrl)("download", ctx.downloadName);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.FaIconComponent, ɵngcc7.TranslateDirective, ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: [".downloader-queue[_ngcontent-%COMP%]{position:fixed;bottom:0;right:2rem;z-index:100;background-color:#fff;width:400px}.downloader-queue-file-list[_ngcontent-%COMP%], .downloader-queue-header[_ngcontent-%COMP%], .downloader-queue-summary[_ngcontent-%COMP%]{padding:10px}.downloader-queue-header[_ngcontent-%COMP%]{background-color:#848484;color:#fff}.downloader-queue-actions[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{color:#fff!important;padding:4px;margin-left:6px}.downloader-queue-file-list[_ngcontent-%COMP%]{margin-bottom:0;list-style:none;max-height:300px;overflow-y:auto}.downloader-queue-file[_ngcontent-%COMP%]{margin-bottom:6px;align-items:center}.downloader-queue-summary[_ngcontent-%COMP%]{border-top:1px solid #eaeaea;background-color:#f9f9f9}"] });
DownloaderQueueComponent.ctorParameters = () => [
    { type: DownloaderService },
    { type: DomSanitizer }
];
__decorate([
    ViewChild('download'),
    __metadata("design:type", ElementRef)
], DownloaderQueueComponent.prototype, "downloadElement", void 0);
DownloaderQueueComponent = __decorate([ __metadata("design:paramtypes", [DownloaderService,
        DomSanitizer])
], DownloaderQueueComponent);

let UIComponentsModule = class UIComponentsModule {
};
UIComponentsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: UIComponentsModule });
UIComponentsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function UIComponentsModule_Factory(t) { return new (t || UIComponentsModule)(); }, imports: [[
            CommonModule$1,
            RouterModule,
            FormsModule,
            CdkTableModule,
            NgbAlertModule,
            FontAwesomeModule,
            UIDirectivesModule,
            NgxSmartModalModule.forChild(),
            I18nModule,
            TranslateModule.forChild(),
            NgSelectModule,
            ContentLoaderModule
        ]] });

let BooleanPipe = class BooleanPipe {
    transform(value) {
        return value ? 'SI' : "NO";
    }
};
BooleanPipe.ɵfac = function BooleanPipe_Factory(t) { return new (t || BooleanPipe)(); };
BooleanPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "booleanPipe", type: BooleanPipe, pure: true });

let IdToStringPipe = class IdToStringPipe {
    transform(n, length = 3) {
        if (n == null) {
            n = 0;
        }
        const z = '0';
        n = n + '';
        return n.length >= length ? n : new Array(length - n.length + 1).join(z) + n;
    }
};
IdToStringPipe.ɵfac = function IdToStringPipe_Factory(t) { return new (t || IdToStringPipe)(); };
IdToStringPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "idToStringPipe", type: IdToStringPipe, pure: true });

let InitialsPipe = class InitialsPipe {
    transform(value, letters = 1) {
        if (isNullOrUndefined(value)) {
            return '';
        }
        let initials = '';
        for (const string of value) {
            if (string == null) {
                continue;
            }
            initials += string.substr(0, letters);
        }
        return initials;
    }
};
InitialsPipe.ɵfac = function InitialsPipe_Factory(t) { return new (t || InitialsPipe)(); };
InitialsPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "initials", type: InitialsPipe, pure: true });

let LocalDatePipe = class LocalDatePipe {
    transform(value, format = DateUtils.HUMAN_FORMAT) {
        if (value == null) {
            return null;
        }
        if (!DateUtils.isLocalDate(value)) {
            return null;
        }
        return DateUtils.formatLocalDate(value, format);
    }
};
LocalDatePipe.ɵfac = function LocalDatePipe_Factory(t) { return new (t || LocalDatePipe)(); };
LocalDatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "localDate", type: LocalDatePipe, pure: true });

let TimePipe = class TimePipe {
    transform(value) {
        if (value == null) {
            return '';
        }
        return TimeUtils.toString(value);
    }
};
TimePipe.ɵfac = function TimePipe_Factory(t) { return new (t || TimePipe)(); };
TimePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "time", type: TimePipe, pure: true });

let TruncatePipe = class TruncatePipe {
    transform(value, limit, trail = '...') {
        if (value == null) {
            return '';
        }
        limit = limit || value.length;
        return value.length > limit ? value.substring(0, limit) + trail : value;
    }
};
TruncatePipe.ɵfac = function TruncatePipe_Factory(t) { return new (t || TruncatePipe)(); };
TruncatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "truncate", type: TruncatePipe, pure: true });

let UIModule = class UIModule {
};
UIModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: UIModule });
UIModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function UIModule_Factory(t) { return new (t || UIModule)(); }, imports: [[
            CommonModule$1,
            FormsModule,
            CdkTableModule,
            NgbModule,
            NgbDropdownModule,
            NgbAlertModule,
            FontAwesomeModule,
            UIComponentsModule,
            UIDirectivesModule
        ],
        UIComponentsModule,
        UIDirectivesModule,
        FontAwesomeModule,
        CdkTableModule,
        NgbModule] });

let LayoutComponent = class LayoutComponent {
    constructor(generalSettingValueService, societiesService) {
        this.generalSettingValueService = generalSettingValueService;
        this.societiesService = societiesService;
    }
    ngOnInit() {
        this.initLogoKey();
    }
    initLogoKey() {
        if (this.logoMap == null) {
            return;
        }
        this.societiesService.getSelectedSociety()
            .pipe(switchMap((society) => this.generalSettingValueService.findByCode('MAIN_LOGO', society.id)))
            .subscribe((list) => {
            if (list.length > 0) {
                const setting = list[0];
                this.logoKey = setting.value;
            }
            else {
                this.logoKey = 'NONE';
            }
        });
    }
    get logoUrl() {
        if (this.logoMap == null) {
            return '/assets/images/logo.svg';
        }
        if (this.logoKey == null) {
            return '';
        }
        if (this.logoKey == 'NONE') {
            return '/assets/images/logo.svg';
        }
        return this.logoMap.get(this.logoKey);
    }
};
LayoutComponent.ɵfac = function LayoutComponent_Factory(t) { return new (t || LayoutComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc10.GeneralSettingValueService), ɵngcc0.ɵɵdirectiveInject(ɵngcc10.SocietiesService)); };
LayoutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LayoutComponent, selectors: [["pwc-layout"]], inputs: { logoMap: "logoMap" }, ngContentSelectors: _c35, decls: 19, vars: 2, consts: [[1, "wrapper"], ["id", "sidebar"], [1, "sidebar-header", 3, "ngClass"], [1, "logo", 3, "src"], ["type", "button", "id", "sidebarCollapse", 1, "btn", "btn-info", 2, "display", "none"], [1, "fas", "fa-align-left"], [1, "list-unstyled", "components"], ["id", "content"], [1, "container-fluid"], ["id", "header"], [1, "row", "header"], [1, "col"], ["app-footer-right", ""]], template: function LayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c34);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "nav", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵelement(5, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "ul", 6);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "header", 9);
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "div", 11);
        ɵngcc0.ɵɵprojection(13, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "main");
        ɵngcc0.ɵɵelement(15, "router-outlet");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "pwc-footer");
        ɵngcc0.ɵɵelementContainerStart(17, 12);
        ɵngcc0.ɵɵprojection(18, 2);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.logoKey != null ? ctx.logoKey : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ctx.logoUrl, ɵngcc0.ɵɵsanitizeUrl);
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc8.RouterOutlet, FooterComponent]; }, styles: ["#header[_ngcontent-%COMP%]{display:block}#sidebarCollapse[_ngcontent-%COMP%]{float:right}#sidebar[_ngcontent-%COMP%]{min-width:250px;max-width:250px;transition:.3s;font-size:12px;background-size:120px}#sidebar[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.mainActive[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#fff;border-bottom:1px solid #fff!important;background:0 0}#sidebar[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#000;background:#ffb600}#sidebar[_ngcontent-%COMP%]   ul.list-2liv[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#000!important}.header[_ngcontent-%COMP%]{background:#7d7d7d!important;padding:5px 0!important;height:initial!important}#sidebar[_ngcontent-%COMP%]   .sidebar-header[_ngcontent-%COMP%]{padding:20px 15px!important;height:initial!important}  #sidebar ul p{color:#fff;padding:10px}  #sidebar ul li a{padding:15px 10px;font-size:1.1em;display:block;text-align:left}  #sidebar ul>li>a pwc-icon,   #sidebar ul>li>a>img{width:25px;text-align:center}  #sidebar ul.list-2liv li a{color:#fff;opacity:.7}  #sidebar ul.list-2liv li a img,   #sidebar ul.list-2liv li a pwc-icon{height:14px}  #sidebar ul.list-2liv li a :hover{opacity:1}  #sidebar ul.list-2liv li.active a{opacity:1}  #sidebar ul.list-2liv hr{margin:0}  #sidebar ul ul a{font-size:.9em!important;padding-left:30px!important}  #sidebar .list-2nd-level{position:absolute;top:0;left:250px;z-index:1;width:280px;display:none}  #sidebar .list-2nd-level .card-body{padding:0!important}  #sidebar.active .list-2nd-level{left:70px}  #sidebar ul.components li a:hover .list-2nd-level{display:block}  #sidebar .list-2nd-level ul li a{margin:0;padding:15px}  #sidebar .list-2nd-level ul li a:hover{text-decoration:underline}  #sidebar .list-2nd-level ul li a img,   #sidebar .list-2nd-level ul li a pwc-icon{width:12px;height:12px;margin:0 10px 0 0}  #sidebar .list-2nd-level ul li a img.icon-active{display:none}  #sidebar .list-2nd-level ul li a img.icon{display:inline}  #sidebar .list-2nd-level ul li a:hover img.icon-active,   #sidebar .list-2nd-level ul li.active a img.icon-active{display:inline}  #sidebar .list-2nd-level ul li a:hover img.icon,   #sidebar .list-2nd-level ul li.active a img.icon{display:none}  #sidebar{min-width:250px;max-width:250px;min-height:100%}  #sidebar img.logo{height:50px;margin:0 auto;display:block}  #sidebar.active{min-width:70px;max-width:70px;text-align:center}  #sidebar .sidebar-header strong{display:none}  #sidebar.active .sidebar-header{padding-left:0;padding-right:0}  #sidebar.active .sidebar-header h3{display:none}  #sidebar.active .sidebar-header strong{display:block}  #sidebar ul li{position:relative}  #sidebar.active ul li a i{margin-right:0;display:block;font-size:1.8em;margin-bottom:5px}  #sidebar.active ul ul a{padding:10px!important}  #sidebar.active .dropdown-toggle::after{top:auto;bottom:10px;right:50%;transform:translateX(50%)}  #sidebar ul li a span{display:inline-block;transition:visibility,opacity .5s linear;opacity:1;word-wrap:break-word;max-width:calc(100% - 45px);overflow:hidden;word-break:break-word;vertical-align:middle}@media (max-width:2px){  #sidebar{min-width:70px;max-width:70px;text-align:center}  #sidebar .sidebar-header{padding-left:0;padding-right:0}  #sidebar .sidebar-header h3{display:none}  #sidebar .sidebar-header strong{display:block}  #sidebar ul li a{text-align:left}  #sidebar ul li a i{margin-right:0;display:block;font-size:1.8em;margin-bottom:5px}  #sidebar ul ul a{padding:10px!important}  #sidebar .dropdown-toggle::after{top:auto;bottom:10px;right:50%;transform:translateX(50%)}  #sidebar ul li a span,   #sidebar ul.list-2liv li a span{display:none!important}}@media (max-width:1px){  #sidebar.active{min-width:80px;max-width:80px;text-align:center;margin-left:-80px!important}  #sidebar{margin-left:0}  #sidebar .sidebar-header{height:80px}  #sidebar .sidebar-header strong{display:none}  #sidebar.active .sidebar-header h3{display:none}  #sidebar.active .sidebar-header strong{display:block}  #sidebar.active ul li a{padding:20px 10px;font-size:.85em}  #sidebar.active ul li a i{margin-right:0;display:block;font-size:1.8em;margin-bottom:5px}  #sidebar.active ul ul a{padding:10px!important}  .dropdown-toggle::after{top:auto;bottom:10px;right:50%;transform:translateX(50%)}}  app-sidebar{display:inherit!important}  #sidebar ul.components li img,   #sidebar ul.components li pwc-icon{height:25px;margin:0 10px}  #sidebar ul.components li,   #sidebar ul.components li a{font-size:12px}  #sidebar .icon-menu{width:25px;height:25px}  #sidebar>.list-unstyled{overflow-y:hidden;min-height:calc(100vh - 80px);margin-bottom:0}"] });
LayoutComponent.ctorParameters = () => [
    { type: GeneralSettingValueService },
    { type: SocietiesService }
];
__decorate([
    Input(),
    __metadata("design:type", Map)
], LayoutComponent.prototype, "logoMap", void 0);
LayoutComponent = __decorate([ __metadata("design:paramtypes", [GeneralSettingValueService,
        SocietiesService])
], LayoutComponent);

let FooterComponent = class FooterComponent {
    constructor() { }
    ngOnInit() {
    }
};
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["pwc-footer"]], ngContentSelectors: _c37, decls: 5, vars: 0, consts: [["id", "footer", 1, "d-flex"], [1, "ml-auto"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c36);
        ɵngcc0.ɵɵelementStart(0, "footer", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵtext(2, "\u00A92021 PwC. All rights reserved. PwC refers to the US member firm of the PwC network or one of its subsidiaries or affiliates. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["#footer[_ngcontent-%COMP%]{height:50px;padding:15px 25px;display:block;line-height:20px}#footer[_ngcontent-%COMP%]   img.logo-footer[_ngcontent-%COMP%]{height:52px}"] });
FooterComponent = __decorate([ __metadata("design:paramtypes", [])
], FooterComponent);

let LayoutModule = class LayoutModule {
};
LayoutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LayoutModule });
LayoutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LayoutModule_Factory(t) { return new (t || LayoutModule)(); }, imports: [[
            CommonModule$1,
            RouterModule,
            I18nModule
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BadgeListComponent, [{
        type: Component,
        args: [{
                selector: 'badge-list',
                template: "<div class=\"form-group form-input-group\" *ngIf=\"items.length\">\n  <label class=\"form-input-label\" *ngIf=\"label\">{{label}}</label>\n  <div class=\"badge-list d-flex flex-row flex-wrap\">\n    <span class=\"badge badge-pill badge-light\" *ngFor=\"let item of items\">\n      {{item.label}}\n      <a href=\"javascript:;\" (click)=\"removeItem(item.id)\" *ngIf=\"item.canRemove\">&times;</a>\n    </span>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { items: [{
            type: Input
        }], remove: [{
            type: Output
        }], label: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BaloonComponent, [{
        type: Component,
        args: [{
                selector: 'baloon',
                template: "<div class=\"baloon\" [ngStyle]=\"styles\">{{content}}</div>\n",
                styles: [".baloon{height:30px;width:30px;border-radius:50%;color:#fff;padding:6px;cursor:pointer;text-align:center}"]
            }]
    }], function () { return []; }, { content: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-button',
                template: "<button type=\"button\" class=\"btn\" [ngClass]=\"classes\" [disabled]=\"disabled\">\n  <ng-content></ng-content>\n  <fa-icon [icon]=\"faCircleNotch\" [spin]=\"true\" *ngIf=\"loading\" class=\"btn-loader\"></fa-icon>\n</button>\n",
                styles: [".btn{position:relative}.btn-loader{position:absolute;right:1em;top:.4em}"]
            }]
    }], function () { return []; }, { variant: [{
            type: Input
        }], disabled: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CollapsableComponent, [{
        type: Component,
        args: [{
                selector: 'collapsable',
                template: "<a href=\"javascript:;\" class=\"collapsable-title\" (click)=\"toggle()\">{{ title }}</a>\n<ng-content *ngIf=\"open\"></ng-content>\n",
                styles: [""]
            }]
    }], function () { return []; }, { open: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DataTableComponent, [{
        type: Component,
        args: [{
                selector: 'data-table',
                template: "<link href=\"//maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css\" rel=\"stylesheet\">\n\n<table cdk-table [dataSource]=\"dataSource\" class=\"table table-striped mb-0\" [ngClass]=\"{'table-hover': hoverable}\">\n  <ng-container cdkColumnDef=\"selected\" *ngIf=\"enableSelect\" sticky>\n    <th cdk-header-cell *cdkHeaderCellDef scope=\"col\" style=\"width: 15px\">\n      <div class=\"custom-control custom-checkbox\">\n        <input type=\"checkbox\" class=\"custom-control-input\" id=\"selectAllRowsCheckBox\"\n               name=\"selectAllRowsCheckBox\" (change)=\"selectVisibleRows()\" [(ngModel)]=\"allSelected\">\n        <label class=\"custom-control-label\" for=\"selectAllRowsCheckBox\"></label>\n      </div>\n    </th>\n    <td cdk-cell *cdkCellDef=\"let row\">\n      <div class=\"custom-control custom-checkbox\">\n        <input type=\"checkbox\" class=\"custom-control-input\" [attr.id]=\"row.id\" [attr.name]=\"row.id\"\n               [checked]=\"row.selected\" [ngModelOptions]=\"{standalone: true}\" [ngModel]=\"row.selected\"\n               (change)=\"selectRows(row.id)\">\n        <label class=\"custom-control-label\" [attr.for]=\"row.id\"></label>\n      </div>\n    </td>\n  </ng-container>\n\n  <ng-container *ngFor=\"let column of columns\" [cdkColumnDef]=\"column.field\">\n    <ng-container *ngIf=\"column.sortable\">\n      <th cdk-header-cell *cdkHeaderCellDef scope=\"col\" [ngStyle]=\"getColumnStyle(column)\" [sortable]=\"column.field\"\n          (sort)=\"onSort($event)\">\n        {{ column.header }}\n        <span *ngIf=\"sortType == column.field && sortReverse == 1\" class=\"fa fa-sort-asc\"></span>\n        <span *ngIf=\"sortType == column.field && sortReverse == 2\" class=\"fa fa-sort-desc\"></span>\n        <span *ngIf=\"sortType == column.field && sortReverse == 0\" class=\"fa fa-sort\"></span>\n      </th>\n    </ng-container>\n    <ng-container *ngIf=\"!column.sortable\">\n      <th cdk-header-cell *cdkHeaderCellDef scope=\"col\" [ngStyle]=\"getColumnStyle(column)\">\n        {{ column.header }}\n      </th>\n    </ng-container>\n\n    <ng-container *ngIf=\"!column.raw\">\n      <td cdk-cell *cdkCellDef=\"let row\" [ngClass]=\"{pointer: hasDblClickHandler(column)}\"\n          (dblclick)=\"handleDoubleClick(column, row)\">{{ column.cell(row) }}</td>\n    </ng-container>\n    <ng-container *ngIf=\"column.raw\">\n      <td cdk-cell *cdkCellDef=\"let row\" [ngClass]=\"{pointer: hasDblClickHandler(column)}\"\n          (dblclick)=\"handleDoubleClick(column, row)\" [innerHTML]=\"column.cell(row)\"></td>\n    </ng-container>\n  </ng-container>\n\n  <ng-container></ng-container>\n\n  <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n  <ng-container *ngIf=\"!detailRowTpl\">\n    <tr cdk-row *cdkRowDef=\"let row; columns: displayedColumns;\"></tr>\n  </ng-container>\n  <ng-container *ngIf=\"detailRowTpl\">\n    <tr cdk-row *cdkRowDef=\"let row; columns: displayedColumns;\" [detailRow]=\"row\" [detailRowTpl]=\"detailRowTpl\"\n        [expand]=\"!row.collapsed\"></tr>\n  </ng-container>\n</table>\n\n<ng-container *ngIf=\"loading$ != null\">\n  <content-loader *ngIf=\"loading$ | async\" [viewBox]=\"'0 0 800 120'\" backgroundColor=\"#ccc\">\n    <svg:rect x=\"20\" y=\"10\" rx=\"3\" ry=\"3\" width=\"90%\" height=\"10\"/>\n    <svg:rect x=\"20\" y=\"30\" rx=\"3\" ry=\"3\" width=\"90%\" height=\"10\"/>\n    <svg:rect x=\"20\" y=\"50\" rx=\"3\" ry=\"3\" width=\"90%\" height=\"10\"/>\n    <svg:rect x=\"20\" y=\"70\" rx=\"3\" ry=\"3\" width=\"90%\" height=\"10\"/>\n    <svg:rect x=\"20\" y=\"90\" rx=\"3\" ry=\"3\" width=\"90%\" height=\"10\"/>\n  </content-loader>\n</ng-container>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { dataSource: [{
            type: Input
        }], columns: [{
            type: Input
        }], customColumns: [{
            type: Input
        }], customColumnDefs: [{
            type: Input
        }], hoverable: [{
            type: Input
        }], loading$: [{
            type: Input
        }], enableSelect: [{
            type: Input
        }], allSelected: [{
            type: Input
        }], select: [{
            type: Output
        }], selectAll: [{
            type: Output
        }], sort: [{
            type: Output
        }], detailRowTpl: [{
            type: Input
        }], table: [{
            type: ViewChild,
            args: [CdkTable, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'list-toolbar',
                template: "<div class=\"card toolbar-card mb-3\" style=\"width: 100%;\">\n  <div class=\"card-body card-table\">\n    <div class=\"d-flex p-2\">\n      <div class=\"m-2 pr-2 toolbar-box-border-right\">\n        <ng-content select=\"[toolbar-actions]\"></ng-content>\n      </div>\n      <div class=\"m-2 align-self-center\">\n        <ng-content select=\"[toolbar-text]\"></ng-content>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: 'alert',
                template: "<ngx-smart-modal #alertModal identifier=\"alertModal\" customClass=\"nsm-dialog-animation-ttb medium-modal\" (onAnyCloseEvent)=\"onAnyClose($event)\">\n  <h5 *ngIf=\"alertModal.hasData()\" [innerHTML]=\"alertModal.getData().message\">\n  </h5>\n</ngx-smart-modal>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc6.NgxSmartModalService }]; }, { onAnyCloseEmitter: [{
            type: Output
        }], model: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-modal',
                template: "<ngx-smart-modal [identifier]=\"id\" [id]=\"id\" customClass=\"modal-content p-0\" force=\"false\" (onClose)=\"onClose()\"\n                 [closable]=\"closable\" [dismissable]=\"dismissable\" [escapable]=\"escapable\">\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title text-uppercase\">\n      <ng-content select=\"[modal-title]\"></ng-content>\n    </h5>\n  </div>\n  <div [ngClass]=\"bodyClass\">\n    <ng-content select=\"[modal-body]\"></ng-content>\n  </div>\n  <div class=\"modal-footer\" *ngIf=\"showFooter\">\n    <ng-content select=\"[modal-footer]\"></ng-content>\n  </div>\n</ngx-smart-modal>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc6.NgxSmartModalService }]; }, { bodyPadding: [{
            type: Input
        }], showFooter: [{
            type: Input
        }], closable: [{
            type: Input
        }], dismissable: [{
            type: Input
        }], opened: [{
            type: Output
        }], closed: [{
            type: Output
        }], id: [{
            type: Input
        }], escapable: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-confirmation-modal',
                template: "<pwc-modal #confirmationModal [id]=\"id\" (closed)=\"onClose()\">\n  <div modal-title>\n    {{title | translate}}\n  </div>\n\n  <div modal-body>\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        {{message | translate}}\n      </div>\n    </div>\n  </div>\n\n  <div modal-footer class=\"text-right\">\n    <button *ngIf=\"negativeButtonText !== ''\" type=\"button\" class=\"btn btn-action btn-danger\" data-dismiss=\"modal\"\n            (click)=\"onNegativeClick()\">{{negativeButtonText | translate}}</button>\n    <button *ngIf=\"positiveButtonText !== ''\" type=\"button\" class=\"btn btn-action btn-success ml-2\"\n            (click)=\"onPositiveClick()\">{{positiveButtonText | translate}}</button>\n  </div>\n</pwc-modal>\n",
                styles: [""]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], title: [{
            type: Input
        }], message: [{
            type: Input
        }], positiveButtonText: [{
            type: Input
        }], negativeButtonText: [{
            type: Input
        }], closed: [{
            type: Output
        }], positiveButtonClick: [{
            type: Output
        }], negativeButtonClick: [{
            type: Output
        }], confirmationModal: [{
            type: ViewChild,
            args: ['confirmationModal', { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SortingArrowsComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-sorting-arrows',
                template: "<span *ngIf=\"selected && direction == 1\" class=\"fa fa-sort-asc\"></span>\n<span *ngIf=\"selected && direction == 2\" class=\"fa fa-sort-desc\"></span>\n<span *ngIf=\"(selected && direction == 0) || (!selected)\" class=\"fa fa-sort\"></span>\n",
                styles: [""]
            }]
    }], function () { return []; }, { selected: [{
            type: Input
        }], direction: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DetailRowDirective, [{
        type: Directive,
        args: [{
                selector: '[detailRow]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, { expanded: [{
            type: HostBinding,
            args: ['class.expanded']
        }], detailRow: [{
            type: Input
        }], template: [{
            type: Input,
            args: ['detailRowTpl']
        }], expand: [{
            type: Input,
            args: ['expand']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgbdSortableHeaderDirective, [{
        type: Directive,
        args: [{
                selector: 'th[sortable]',
                host: {
                    '[class.sortable]': 'true',
                    '[class.asc]': `direction === 'asc'`,
                    '[class.desc]': `direction === 'desc'`,
                    '(click)': 'rotate()'
                }
            }]
    }], function () { return []; }, { direction: [{
            type: Input
        }], sort: [{
            type: Output
        }], sortable: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UIDirectivesModule, { declarations: function () { return [DetailRowDirective,
        NgbdSortableHeaderDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DetailRowDirective,
        NgbdSortableHeaderDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UIDirectivesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DetailRowDirective,
                    NgbdSortableHeaderDirective
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    DetailRowDirective,
                    NgbdSortableHeaderDirective
                ]
            }]
    }], null, null); })();
const ɵPaginationConfig_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PaginationConfig);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaginationConfig, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-pagination',
                template: "\n<ng-template #first><span aria-hidden=\"true\" i18n=\"@@ngb.pagination.first\">&laquo;&laquo;</span></ng-template>\n<ng-template #previous><span aria-hidden=\"true\" i18n=\"@@ngb.pagination.previous\"><fa-icon\n  [icon]=\"faAngleLeft\"></fa-icon></span></ng-template>\n<ng-template #next><span aria-hidden=\"true\" i18n=\"@@ngb.pagination.next\"><fa-icon\n  [icon]=\"faAngleRight\"></fa-icon></span></ng-template>\n<ng-template #last><span aria-hidden=\"true\" i18n=\"@@ngb.pagination.last\">&raquo;&raquo;</span></ng-template>\n<ng-template #ellipsis>...</ng-template>\n<ng-template #defaultNumber let-page let-currentPage=\"currentPage\">\n  {{ page }}\n  <span *ngIf=\"page === currentPage\" class=\"sr-only\">(current)</span>\n</ng-template>\n<ul [class]=\"'pagination' + (size ? ' pagination-' + size : '')\">\n  <li *ngIf=\"boundaryLinks\" class=\"page-item\"\n      [class.disabled]=\"previousDisabled()\">\n    <a aria-label=\"First\" i18n-aria-label=\"@@ngb.pagination.first-aria\" class=\"page-link\" href\n       (click)=\"selectPage(1); $event.preventDefault()\" [attr.tabindex]=\"(hasPrevious() ? null : '-1')\">\n      <ng-template [ngTemplateOutlet]=\"tplFirst?.templateRef || first\"\n                   [ngTemplateOutletContext]=\"{disabled: previousDisabled(), currentPage: page}\"></ng-template>\n    </a>\n  </li>\n  <li *ngIf=\"directionLinks\" class=\"page-item\"\n      [class.disabled]=\"previousDisabled()\">\n    <a aria-label=\"Previous\" i18n-aria-label=\"@@ngb.pagination.previous-aria\" class=\"page-link\" href\n       (click)=\"selectPage(page-1); $event.preventDefault()\" [attr.tabindex]=\"(hasPrevious() ? null : '-1')\">\n      <ng-template [ngTemplateOutlet]=\"tplPrevious?.templateRef || previous\"\n                   [ngTemplateOutletContext]=\"{disabled: previousDisabled()}\"></ng-template>\n    </a>\n  </li>\n  <li class=\"page-item page-number-selector\">\n    <div class=\"form-group form-input-group\">\n      <input type=\"number\" id=\"page-number\" class=\"form-control form-input page-number-input\" [(ngModel)]=\"tmpPage\"\n             (keyup.enter)=\"applyPageChange()\" (blur)=\"resetPageChange()\">\n    </div>\n  </li>\n  <li class=\"page-item disabled\">\n    <a class=\"page-link\">\n      di {{pageCount}}\n    </a>\n  </li>\n  <li *ngIf=\"directionLinks\" class=\"page-item\" [class.disabled]=\"nextDisabled()\">\n    <a aria-label=\"Next\" i18n-aria-label=\"@@ngb.pagination.next-aria\" class=\"page-link\" href\n       (click)=\"selectPage(page+1); $event.preventDefault()\" [attr.tabindex]=\"(hasNext() ? null : '-1')\">\n      <ng-template [ngTemplateOutlet]=\"tplNext?.templateRef || next\"\n                   [ngTemplateOutletContext]=\"{disabled: nextDisabled(), currentPage: page}\"></ng-template>\n    </a>\n  </li>\n  <li *ngIf=\"boundaryLinks\" class=\"page-item\" [class.disabled]=\"nextDisabled()\">\n    <a aria-label=\"Last\" i18n-aria-label=\"@@ngb.pagination.last-aria\" class=\"page-link\" href\n       (click)=\"selectPage(pageCount); $event.preventDefault()\" [attr.tabindex]=\"(hasNext() ? null : '-1')\">\n      <ng-template [ngTemplateOutlet]=\"tplLast?.templateRef || last\"\n                   [ngTemplateOutletContext]=\"{disabled: nextDisabled(), currentPage: page}\"></ng-template>\n    </a>\n  </li>\n\n  <li class=\"page-item ml-4 d-flex flex-row align-items-center\" *ngIf=\"showCollectionSize\">\n    <span class=\"mr-2\" translate>pagination.collection-size</span>\n    <span>{{collectionSize}}</span>\n  </li>\n</ul>\n",
                styles: [""]
            }]
    }], function () { return [{ type: PaginationConfig }]; }, { showCollectionSize: [{
            type: Input
        }], page: [{
            type: Input
        }], pageChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }], boundaryLinks: [{
            type: Input
        }], directionLinks: [{
            type: Input
        }], ellipses: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], rotate: [{
            type: Input
        }], size: [{
            type: Input
        }], tplEllipsis: [{
            type: ContentChild,
            args: [NgbPaginationEllipsis]
        }], tplFirst: [{
            type: ContentChild,
            args: [NgbPaginationFirst]
        }], tplLast: [{
            type: ContentChild,
            args: [NgbPaginationLast]
        }], tplNext: [{
            type: ContentChild,
            args: [NgbPaginationNext]
        }], tplNumber: [{
            type: ContentChild,
            args: [NgbPaginationNumber]
        }], tplPrevious: [{
            type: ContentChild,
            args: [NgbPaginationPrevious]
        }], collectionSize: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-breadcrumbs',
                template: "<nav [ngClass]=\"getBreadcrumbWrapperClass()\" aria-label=\"breadcrumb\">\n  <div class=\"breadcrumb-prefix\">\n    <a [routerLink]=\"homeItem.url\">\n      <img src=\"/assets/images/icons/docs-home.svg\" alt=\"Home\">\n    </a>\n  </div>\n  <ol [ngClass]=\"getBreadcrumbClass()\">\n    <li class=\"breadcrumb-item\" *ngFor=\"let item of items\">\n      <a [routerLink]=\"item.url\">{{ item.label }}</a>\n    </li>\n  </ol>\n</nav>\n",
                styles: [".breadcrumb{display:inline-block;height:40px;min-width:800px;max-width:calc(100% - 80px);margin-bottom:0;padding-left:.5rem;padding-right:.5rem;background-color:#fff}.breadcrumb-wrapper{margin-bottom:1rem}.breadcrumb,.breadcrumb-postfix,.breadcrumb-prefix{vertical-align:middle}.breadcrumb-postfix,.breadcrumb-prefix{display:inline-block;height:40px;width:40px;text-align:center;background-color:#eaebea}.breadcrumb-postfix a,.breadcrumb-prefix a{display:inline-block;padding:11px}.breadcrumb-item{display:inline-block;line-height:40px}.breadcrumb-full-width{display:inline-block;height:40px;min-width:800px;width:100%;margin-bottom:0;padding-left:.5rem;padding-right:.5rem;background-color:#fff}.breadcrumb-full-width-wrapper{margin-bottom:1rem;display:flex}.breadcrumb-full-width,.breadcrumb-full-width-postfix,.breadcrumb-full-width-prefix{vertical-align:middle}.breadcrumb-full-width-postfix,.breadcrumb-full-width-prefix{display:inline-block;height:40px;width:40px;text-align:center;background-color:#eaebea}.breadcrumb-full-width-postfix a,.breadcrumb-full-width-prefix a{display:inline-block;padding:11px}.breadcrumb-full-width-item{display:inline-block;line-height:40px}"]
            }]
    }], function () { return []; }, { items: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageSizeSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-page-size-selector',
                template: "<ng-select style=\"width: auto;\"\n           name=\"pageSize\"\n           autofocus=\"false\"\n           class=\"custom\"\n           bindValue=\"value\"\n           [ngModel]=\"pageSize\"\n           (change)=\"pageSizeChange.emit($event)\"\n           [clearable]=\"false\"\n           [searchable]=\"false\">\n  <ng-option *ngFor=\"let option of options\"\n             [value]=\"option.value\">{{ 'generic.action.switch-row-per-page' | translate:{rows: option.value} }}\n  </ng-option>\n</ng-select>\n",
                styles: [""]
            }]
    }], function () { return []; }, { options: [{
            type: Input
        }], pageSizeChange: [{
            type: Output
        }], pageSize: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DownloaderQueueComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-downloader-queue',
                template: "<div class=\"downloader-queue\" *ngIf=\"downloaderService.isNotEmpty()\">\n  <div class=\"downloader-queue-header d-flex justify-content-between\">\n    <div style=\"line-height: 22px\">\n      <span *ngIf=\"downloaderService.isDownloading\" translate>downloader.header.in-progress</span>\n      <span *ngIf=\"downloaderService.isSuccess\" translate>downloader.header.success</span>\n      <span *ngIf=\"downloaderService.isError\" translate>downloader.header.error</span>\n    </div>\n    <div class=\"downloader-queue-actions\">\n      <button class=\"btn btn-sm\" type=\"button\" (click)=\"hideList()\" *ngIf=\"listVisible\">\n        <fa-icon [icon]=\"faAngleDown\"></fa-icon>\n      </button>\n      <button class=\"btn btn-sm\" type=\"button\" (click)=\"showList()\" *ngIf=\"!listVisible\">\n        <fa-icon [icon]=\"faAngleUp\"></fa-icon>\n      </button>\n      <button class=\"btn btn-sm\" type=\"button\" (click)=\"closeDialog()\">\n        <fa-icon [icon]=\"faTimes\"></fa-icon>\n      </button>\n    </div>\n  </div>\n\n  <ul class=\"downloader-queue-file-list\" *ngIf=\"downloaderService.hasItems && listVisible\">\n    <li *ngFor=\"let item of downloaderService.queue\" class=\"downloader-queue-file d-flex justify-content-between\">\n      <div class=\"file-name\" [ngClass]=\"{'text-danger': item.isError}\">\n        {{item.fileName}}\n      </div>\n      <div class=\"downloader-queue-icon\">\n        <fa-icon [icon]=\"faCircleNotch\" [spin]=\"true\" *ngIf=\"item.isProgress\"></fa-icon>\n        <fa-icon [icon]=\"faTimesCircle\" *ngIf=\"item.isError && !item.isProgress\" class=\"text-danger\"></fa-icon>\n        <a href=\"javascript:;\" (click)=\"openFile(item)\">\n          <fa-icon [icon]=\"faCheckCircle\" *ngIf=\"item.isSuccess && !item.isProgress\" class=\"text-success\"></fa-icon>\n        </a>\n      </div>\n    </li>\n  </ul>\n</div>\n\n<a #download\n   [href]=\"sanitizeUrl(downloadUrl)\"\n   [download]=\"downloadName\"\n   target=\"_blank\"\n   style=\"display:none!important\"></a>\n",
                styles: [".downloader-queue{position:fixed;bottom:0;right:2rem;z-index:100;background-color:#fff;width:400px}.downloader-queue-file-list,.downloader-queue-header,.downloader-queue-summary{padding:10px}.downloader-queue-header{background-color:#848484;color:#fff}.downloader-queue-actions .btn{color:#fff!important;padding:4px;margin-left:6px}.downloader-queue-file-list{margin-bottom:0;list-style:none;max-height:300px;overflow-y:auto}.downloader-queue-file{margin-bottom:6px;align-items:center}.downloader-queue-summary{border-top:1px solid #eaeaea;background-color:#f9f9f9}"]
            }]
    }], function () { return [{ type: ɵngcc10.DownloaderService }, { type: ɵngcc11.DomSanitizer }]; }, { downloadElement: [{
            type: ViewChild,
            args: ['download']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UIComponentsModule, { declarations: function () { return [BadgeListComponent,
        BaloonComponent,
        ButtonComponent,
        CollapsableComponent,
        DataTableComponent,
        ListToolbarComponent,
        AlertComponent,
        ConfirmationModalComponent,
        ModalComponent,
        SortingArrowsComponent,
        PaginationComponent,
        PageSizeSelectorComponent,
        BreadcrumbsComponent,
        DownloaderQueueComponent]; }, imports: function () { return [CommonModule$1,
        RouterModule,
        FormsModule,
        CdkTableModule,
        NgbAlertModule,
        FontAwesomeModule,
        UIDirectivesModule, ɵngcc6.NgxSmartModalModule, I18nModule, ɵngcc7.TranslateModule, NgSelectModule,
        ContentLoaderModule]; }, exports: function () { return [BadgeListComponent,
        BaloonComponent,
        ButtonComponent,
        CollapsableComponent,
        DataTableComponent,
        ListToolbarComponent,
        AlertComponent,
        ConfirmationModalComponent,
        ModalComponent,
        SortingArrowsComponent,
        PaginationComponent,
        PageSizeSelectorComponent,
        BreadcrumbsComponent,
        DownloaderQueueComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UIComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BadgeListComponent,
                    BaloonComponent,
                    ButtonComponent,
                    CollapsableComponent,
                    DataTableComponent,
                    ListToolbarComponent,
                    AlertComponent,
                    ConfirmationModalComponent,
                    ModalComponent,
                    SortingArrowsComponent,
                    PaginationComponent,
                    PageSizeSelectorComponent,
                    BreadcrumbsComponent,
                    DownloaderQueueComponent
                ],
                imports: [
                    CommonModule$1,
                    RouterModule,
                    FormsModule,
                    CdkTableModule,
                    NgbAlertModule,
                    FontAwesomeModule,
                    UIDirectivesModule,
                    NgxSmartModalModule.forChild(),
                    I18nModule,
                    TranslateModule.forChild(),
                    NgSelectModule,
                    ContentLoaderModule
                ],
                exports: [
                    BadgeListComponent,
                    BaloonComponent,
                    ButtonComponent,
                    CollapsableComponent,
                    DataTableComponent,
                    ListToolbarComponent,
                    AlertComponent,
                    ConfirmationModalComponent,
                    ModalComponent,
                    SortingArrowsComponent,
                    PaginationComponent,
                    PageSizeSelectorComponent,
                    BreadcrumbsComponent,
                    DownloaderQueueComponent
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BooleanPipe, [{
        type: Pipe,
        args: [{ name: 'booleanPipe' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IdToStringPipe, [{
        type: Pipe,
        args: [{ name: 'idToStringPipe' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InitialsPipe, [{
        type: Pipe,
        args: [{
                name: 'initials'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalDatePipe, [{
        type: Pipe,
        args: [{
                name: 'localDate'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimePipe, [{
        type: Pipe,
        args: [{
                name: 'time'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TruncatePipe, [{
        type: Pipe,
        args: [{
                name: 'truncate'
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UIModule, { declarations: function () { return [BooleanPipe,
        IdToStringPipe,
        InitialsPipe,
        LocalDatePipe,
        TimePipe,
        TruncatePipe]; }, imports: function () { return [CommonModule$1,
        FormsModule,
        CdkTableModule,
        NgbModule,
        NgbDropdownModule,
        NgbAlertModule,
        FontAwesomeModule,
        UIComponentsModule,
        UIDirectivesModule]; }, exports: function () { return [UIComponentsModule,
        UIDirectivesModule,
        FontAwesomeModule,
        CdkTableModule,
        NgbModule,
        BooleanPipe,
        IdToStringPipe,
        InitialsPipe,
        LocalDatePipe,
        TimePipe,
        TruncatePipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UIModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BooleanPipe,
                    IdToStringPipe,
                    InitialsPipe,
                    LocalDatePipe,
                    TimePipe,
                    TruncatePipe,
                ],
                imports: [
                    CommonModule$1,
                    FormsModule,
                    CdkTableModule,
                    NgbModule,
                    NgbDropdownModule,
                    NgbAlertModule,
                    FontAwesomeModule,
                    UIComponentsModule,
                    UIDirectivesModule
                ],
                exports: [
                    UIComponentsModule,
                    UIDirectivesModule,
                    FontAwesomeModule,
                    CdkTableModule,
                    NgbModule,
                    BooleanPipe,
                    IdToStringPipe,
                    InitialsPipe,
                    LocalDatePipe,
                    TimePipe,
                    TruncatePipe,
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-layout',
                template: "<div class=\"wrapper\">\n  <nav id=\"sidebar\">\n    <div class=\"sidebar-header\" [ngClass]=\"logoKey != null ? logoKey : ''\">\n      <img [src]=\"logoUrl\" class=\"logo\">\n      <button type=\"button\" id=\"sidebarCollapse\" class=\"btn btn-info\" style=\"display: none\">\n        <i class=\"fas fa-align-left\"></i>\n      </button>\n    </div>\n\n    <ul class=\"list-unstyled components\">\n      <ng-content select=\"[app-nav-menu]\"></ng-content>\n    </ul>\n  </nav>\n\n  <div id=\"content\">\n    <div class=\"container-fluid\">\n      <!-- header -->\n      <header id=\"header\">\n        <div class=\"row header\">\n          <div class=\"col\">\n            <ng-content select=\"[app-header]\"></ng-content>\n          </div>\n        </div>\n      </header>\n\n      <!-- routes will be rendered here -->\n\n      <main>\n        <router-outlet></router-outlet>\n      </main>\n\n    </div>\n    <!-- footer -->\n    <pwc-footer>\n      <ng-container app-footer-right>\n        <ng-content select=\"[app-footer-right]\"></ng-content>\n      </ng-container>\n    </pwc-footer>\n  </div>\n</div>\n",
                styles: ["#header{display:block}#sidebarCollapse{float:right}#sidebar{min-width:250px;max-width:250px;transition:.3s;font-size:12px;background-size:120px}#sidebar ul li.mainActive>a{color:#fff;border-bottom:1px solid #fff!important;background:0 0}#sidebar ul li.active>a{color:#000;background:#ffb600}#sidebar ul.list-2liv li a:hover{color:#000!important}.header{background:#7d7d7d!important;padding:5px 0!important;height:initial!important}#sidebar .sidebar-header{padding:20px 15px!important;height:initial!important}::ng-deep #sidebar ul p{color:#fff;padding:10px}::ng-deep #sidebar ul li a{padding:15px 10px;font-size:1.1em;display:block;text-align:left}::ng-deep #sidebar ul>li>a pwc-icon,::ng-deep #sidebar ul>li>a>img{width:25px;text-align:center}::ng-deep #sidebar ul.list-2liv li a{color:#fff;opacity:.7}::ng-deep #sidebar ul.list-2liv li a img,::ng-deep #sidebar ul.list-2liv li a pwc-icon{height:14px}::ng-deep #sidebar ul.list-2liv li a :hover{opacity:1}::ng-deep #sidebar ul.list-2liv li.active a{opacity:1}::ng-deep #sidebar ul.list-2liv hr{margin:0}::ng-deep #sidebar ul ul a{font-size:.9em!important;padding-left:30px!important}::ng-deep #sidebar .list-2nd-level{position:absolute;top:0;left:250px;z-index:1;width:280px;display:none}::ng-deep #sidebar .list-2nd-level .card-body{padding:0!important}::ng-deep #sidebar.active .list-2nd-level{left:70px}::ng-deep #sidebar ul.components li a:hover .list-2nd-level{display:block}::ng-deep #sidebar .list-2nd-level ul li a{margin:0;padding:15px}::ng-deep #sidebar .list-2nd-level ul li a:hover{text-decoration:underline}::ng-deep #sidebar .list-2nd-level ul li a img,::ng-deep #sidebar .list-2nd-level ul li a pwc-icon{width:12px;height:12px;margin:0 10px 0 0}::ng-deep #sidebar .list-2nd-level ul li a img.icon-active{display:none}::ng-deep #sidebar .list-2nd-level ul li a img.icon{display:inline}::ng-deep #sidebar .list-2nd-level ul li a:hover img.icon-active,::ng-deep #sidebar .list-2nd-level ul li.active a img.icon-active{display:inline}::ng-deep #sidebar .list-2nd-level ul li a:hover img.icon,::ng-deep #sidebar .list-2nd-level ul li.active a img.icon{display:none}::ng-deep #sidebar{min-width:250px;max-width:250px;min-height:100%}::ng-deep #sidebar img.logo{height:50px;margin:0 auto;display:block}::ng-deep #sidebar.active{min-width:70px;max-width:70px;text-align:center}::ng-deep #sidebar .sidebar-header strong{display:none}::ng-deep #sidebar.active .sidebar-header{padding-left:0;padding-right:0}::ng-deep #sidebar.active .sidebar-header h3{display:none}::ng-deep #sidebar.active .sidebar-header strong{display:block}::ng-deep #sidebar ul li{position:relative}::ng-deep #sidebar.active ul li a i{margin-right:0;display:block;font-size:1.8em;margin-bottom:5px}::ng-deep #sidebar.active ul ul a{padding:10px!important}::ng-deep #sidebar.active .dropdown-toggle::after{top:auto;bottom:10px;right:50%;transform:translateX(50%)}::ng-deep #sidebar ul li a span{display:inline-block;transition:visibility,opacity .5s linear;opacity:1;word-wrap:break-word;max-width:calc(100% - 45px);overflow:hidden;word-break:break-word;vertical-align:middle}@media (max-width:2px){::ng-deep #sidebar{min-width:70px;max-width:70px;text-align:center}::ng-deep #sidebar .sidebar-header{padding-left:0;padding-right:0}::ng-deep #sidebar .sidebar-header h3{display:none}::ng-deep #sidebar .sidebar-header strong{display:block}::ng-deep #sidebar ul li a{text-align:left}::ng-deep #sidebar ul li a i{margin-right:0;display:block;font-size:1.8em;margin-bottom:5px}::ng-deep #sidebar ul ul a{padding:10px!important}::ng-deep #sidebar .dropdown-toggle::after{top:auto;bottom:10px;right:50%;transform:translateX(50%)}::ng-deep #sidebar ul li a span,::ng-deep #sidebar ul.list-2liv li a span{display:none!important}}@media (max-width:1px){::ng-deep #sidebar.active{min-width:80px;max-width:80px;text-align:center;margin-left:-80px!important}::ng-deep #sidebar{margin-left:0}::ng-deep #sidebar .sidebar-header{height:80px}::ng-deep #sidebar .sidebar-header strong{display:none}::ng-deep #sidebar.active .sidebar-header h3{display:none}::ng-deep #sidebar.active .sidebar-header strong{display:block}::ng-deep #sidebar.active ul li a{padding:20px 10px;font-size:.85em}::ng-deep #sidebar.active ul li a i{margin-right:0;display:block;font-size:1.8em;margin-bottom:5px}::ng-deep #sidebar.active ul ul a{padding:10px!important}::ng-deep .dropdown-toggle::after{top:auto;bottom:10px;right:50%;transform:translateX(50%)}}::ng-deep app-sidebar{display:inherit!important}::ng-deep #sidebar ul.components li img,::ng-deep #sidebar ul.components li pwc-icon{height:25px;margin:0 10px}::ng-deep #sidebar ul.components li,::ng-deep #sidebar ul.components li a{font-size:12px}::ng-deep #sidebar .icon-menu{width:25px;height:25px}::ng-deep #sidebar>.list-unstyled{overflow-y:hidden;min-height:calc(100vh - 80px);margin-bottom:0}"]
            }]
    }], function () { return [{ type: ɵngcc10.GeneralSettingValueService }, { type: ɵngcc10.SocietiesService }]; }, { logoMap: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-footer',
                template: "<footer id=\"footer\" class=\"d-flex\">\n  <div>\u00A92021 PwC. All rights reserved. PwC refers to the US member firm of the PwC network or\n    one of its subsidiaries or affiliates.\n  </div>\n  <div class=\"ml-auto\">\n    <ng-content select=\"[app-footer-right]\"></ng-content>\n  </div>\n</footer>\n",
                styles: ["#footer{height:50px;padding:15px 25px;display:block;line-height:20px}#footer img.logo-footer{height:52px}"]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LayoutModule, { declarations: function () { return [LayoutComponent,
        FooterComponent]; }, imports: function () { return [CommonModule$1,
        RouterModule,
        I18nModule]; }, exports: function () { return [LayoutComponent,
        FooterComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LayoutComponent,
                    FooterComponent
                ],
                imports: [
                    CommonModule$1,
                    RouterModule,
                    I18nModule
                ],
                exports: [
                    LayoutComponent,
                    FooterComponent
                ]
            }]
    }], null, null); })();

class BadgeListItem {
    constructor() {
        this.canRemove = true;
    }
}

class ColumnDef {
    constructor() {
        this.sortable = true;
        this.raw = false;
    }
}

class DataTableConfig {
    constructor(config = {}) {
        this.columns = [];
        this.customColumns = [];
        for (const key of Object.keys(config)) {
            this[key] = config[key];
        }
    }
}

class Collapsable {
    constructor(model, collapsed = true) {
        this.model = model;
        this.collapsed = collapsed;
    }
}

/*
 * Public API Surface of ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AlertModal, BadgeListComponent, BadgeListItem, BaloonComponent, BooleanPipe, BreadcrumbsComponent, ButtonComponent, Collapsable, CollapsableComponent, ColumnDef, ConfirmationModalComponent, DataTableComponent, DataTableConfig, DetailRowDirective, DownloaderQueueComponent, IdToStringPipe, InitialsPipe, LayoutComponent, LayoutModule, ListToolbarComponent, ModalComponent, NgbdSortableHeaderDirective, PageSizeSelectorComponent, PaginationComponent, PaginationConfig, SortingArrowsComponent, TimePipe, UIComponentsModule, UIDirectivesModule, UIModule, getValueInRange, isNumber, toInteger, LocalDatePipe as ɵa, TruncatePipe as ɵb, FooterComponent as ɵc };

//# sourceMappingURL=pwc-ui.js.map